// sekcie_v1 (20. 10. 2026, 0.J): DetailRow je jeden, v components/Ui.jsx
// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 2 miest
// ╔══════════════════════════════════════════════════════════════════╗
// ║  _ModuleTemplate.jsx — REFERENČNÁ ŠABLÓNA MODULU MATRIX v2        ║
// ║  Ústava 9.D.1 bod 2 — anti-chyba systém.                          ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  NOVÝ MODUL VZNIKÁ KÓPIOU TOHTO SÚBORU — NIKDY NIE OD NULY.       ║
// ║  Tým sa ústavné systémové veci NEDAJÚ vynechať.                   ║
// ║                                                                  ║
// ║  POSTUP (ústava 9.D.1):                                          ║
// ║   1. PRE-FLIGHT dokument — schváli Mirko PRED prvým riadkom.      ║
// ║   2. cp _ModuleTemplate.jsx → views/MojModul.jsx                 ║
// ║   3. Vyplň CFG · EDIT_FIELDS · STATUS_FILTERS · polia formulára.  ║
// ║   4. Nahraď TODO značky. Skontroluj DoD checklist (dole).         ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  ČO JE V ŠABLÓNE ZABUDOVANÉ (ústavné systémové veci):            ║
// ║   • master-detail layout ......................... sek. 56       ║
// ║   • LOCK multi-user (cez useRecordEditor) ........ sek. 53.7      ║
// ║   • DIRTY dialóg pri odchode ..................... sek. 53.1      ║
// ║   • Form → Confirm + DIFF pred uložením .......... 12.0/3 · 53.8  ║
// ║   • audit kto/čo/kedy (HistoryPanel + auto-log) .. 12.0/1         ║
// ║   • fulltext hľadanie v zozname .................. sek. 56        ║
// ║   • SearchableSelect (žiadny plain <select>) ..... sek. 56.11     ║
// ║   • TINT pozadia (žiadne inline farby) ........... sek. 21.15     ║
// ║   • dedup kontrola (409 z backendu) .............. sek. 13        ║
// ║   • klávesnica (mod+N, /) + cheatsheet ........... sek. 54        ║
// ║   • breadcrumb — rieši Layout .................... sek. 53.2      ║
// ╚══════════════════════════════════════════════════════════════════╝

import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react'
import useLiveRefresh from '../hooks/useLiveRefresh.js'
import { COLORS, TYPO, SPACE, RADIUS, TINT, SK, todayLocal, hladaj } from '../theme.js'
import {
  PageHeader, MasterDetail, SearchInput, ListRow, ListStatusBar,
  FilterChips, KpiRow, KpiCard, Tabs, EmptyPane, SearchableSelect, DetailRow } from '../components/Ui.jsx'
import { Modal } from '../components/Modal.jsx'
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import { HistoryPanel } from '../components/HistoryPanel.jsx'
import { useToast } from '../components/Toast.jsx'
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useRecordEditor } from '../hooks/useRecordEditor.js'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { usePositionMemory } from '../hooks/usePositionMemory.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import PozicovnaKalendar from './PozicovnaKalendar.jsx'
import PozicovnaReporty from './PozicovnaReporty.jsx'
import { usePersony } from '../lib/persony.js'
import AttachmentsPanel from '../components/AttachmentsPanel.jsx'
import HelpHint from '../components/HelpHint.jsx'
import NavIcon from '../components/NavIcon.jsx'
import RowMenu from '../components/RowMenu.jsx'
import ExportMenu from '../components/ExportMenu.jsx'
import { useNavigate } from 'react-router-dom'
import { useConfirm } from '../components/ConfirmDialog.jsx'
import qrcodegen from 'qrcode-generator'

// ╔═══ KONFIGURÁCIA MODULU — VYPLŇ PRI KOPÍROVANÍ ═══════════════════╗
// DÔLEŽITÉ: resource MUSÍ byť presne cesta API segmentu (napr. 'work-schedule'
// pre /api/work-schedule). Server zapisuje audit pod týmto názvom — ak sa
// nezhoduje, HistoryPanel nenájde históriu (ústava-review 9.D.3).
const CFG = {
  resource:    'loan-items',
  apiBase:     '/api/loan-items',
  titlePlural: 'Požičovňa',
  newLabel:    'Nová položka',
}

// Polia pre DIFF (ústava 53.8) — useRecordEditor ich porovná initial vs. zmenené.
// label = ako sa pole volá v Confirm prehľade. format = voliteľné zobrazenie.
const EDIT_FIELDS = [
  { name: 'code',          label: 'Kód' },
  { name: 'name',          label: 'Názov' },
  { name: 'category',      label: 'Kategória' },
  { name: 'part_type',     label: 'Druh dielu' },
  { name: 'description',   label: 'Popis produktu' },
  { name: 'nfc_tag',       label: 'NFC tag' },
  { name: 'tracking',      label: 'Režim' },
  { name: 'serial_number', label: 'Výrobné číslo' },
  { name: 'model',         label: 'Model' },
  { name: 'color',         label: 'Farba' },
  { name: 'photo_url',     label: 'Fotka' },
  // Omietačka — 3 zameniteľné časti (Mirko 2026-06-10)
  { name: 'frame_serial',      label: 'Rám — výr. číslo' },
  { name: 'motor_serial',      label: 'Motor — výr. číslo' },
  { name: 'compressor_serial', label: 'Kompresor — výr. číslo' },
  { name: 'compressor_color',  label: 'Kompresor — farba' },
  { name: 'motor_connector',      label: 'Koncovka motora' },
  { name: 'compressor_connector', label: 'Koncovka kompresora' },
  { name: 'plc_enabled',   label: 'PLC monitorovanie' },
  { name: 'plc_device_id', label: 'PLC ID/IP' },
  { name: 'qty',           label: 'Počet ks' },
  { name: 'rate',          label: 'Sadzba' },
  { name: 'rate_unit',     label: 'Jednotka sadzby' },
  { name: 'status',        label: 'Stav položky' },
  { name: 'notes',         label: 'Poznámka' },
]

// Filter chips (ústava 21.15 — farby gest). key 'all' = bez filtra.
const STATUS_FILTERS = [
  { key: 'all',         label: 'Všetko',     color: COLORS.muted },
  { key: 'dostupne',    label: 'Dostupné',   color: COLORS.add },
  { key: 'pozicane',    label: 'Požičané',   color: COLORS.total },
  { key: 'v_servise',   label: 'V servise',  color: COLORS.warn },
  { key: 'vyradene',    label: 'Vyradené',   color: COLORS.muted },
]
// ks-polozky (na mnozstvo): backend status neprepina na 'pozicane' (UPDATE ma WHERE tracking='kus') —
// efektivny stav sa odvodi z available_ks/loaned_ks z GET /api/loan-items (oprava 2026-09-14, OH.01/OH.02)
const effStatus = r => (r && r.tracking === 'ks' && r.status === 'dostupne' && (Number(r.loaned_ks) || 0) > 0 && (Number(r.available_ks) || 0) <= 0) ? 'pozicane' : ((r && r.status) || '')
const ksHasLoan = r => !!(r && r.tracking === 'ks' && (Number(r.loaned_ks) || 0) > 0)
const STATUS_LABEL = {
  dostupne:  'Dostupné',
  pozicane:  'Požičané',
  v_servise: 'V servise',
  vyradene:  'Vyradené',
}
// Kategórie do lišty (Mirko 2026-06-10) — rýchly filter podľa typu stroja
const CATEGORY_BAR = ['Omietačka', 'Hlavný motor', 'Malý kompresor', 'Silomat', 'Kapota', 'Hadica na suchú zmes', 'Hruška', 'Lešenie']
// Omietačka = JEDNA položka zložená z 3 zameniteľných častí (Mirko 2026-06-10):
//   • Rám — VŽDY zostáva (identita stroja), má výr. číslo
//   • Hlavný motor s prevodovkou — vymeniteľný, má výr. číslo
//   • Kompresor — vymeniteľný, má výr. číslo + farbu
const isOmietacka = (cat) => /omieta/i.test((cat || '').toString())
// Kód stroja (Mirko 2026-06-10): číslo 1–25+ → zobraz „č.XX". Ak už má „č." alebo nie je číslo, ber ako je.
const fmtCode = (code) => { const c = (code || '').toString().trim(); if (!c) return ''; return /^\d+$/.test(c) ? 'č.' + c : c }
const OMIETACKA_HINT = 'Omietačka = jedna položka z 3 zameniteľných častí. RÁM vždy zostáva (identita stroja). KOMPRESOR a MOTOR sa môžu medzi strojmi zamieňať — preto má každá časť vlastné výrobné číslo (kompresor aj farbu).'
const TRACKING_OPTS = [
  { value: 'kus', label: 'Na KUS (s výrobným číslom)' },
  { value: 'ks',  label: 'Na MNOŽSTVO (Ks)' },
]
// DRUH DIELU (Mirko 2026-10-04): „kompresor omietačky je niečo iné ako kompresor sila".
// Rám je základ a vždy zostáva — menia sa hlavný motor a malý kompresor. Podľa tohto poľa
// (nie podľa názvu kategórie) Matrix rozhoduje, čo sa smie osadiť do ktorého slotu omietačky.
const PART_TYPE_OPTS = [
  { value: 'hlavny_motor',   label: 'Hlavný motor s prevodovkou', popis: 'Osadí sa do slotu Motor na omietačke' },
  { value: 'maly_kompresor', label: 'Malý kompresor (na omietačke)', popis: 'Osadí sa do slotu Kompresor na omietačke' },
  { value: 'kompresor_sila', label: 'Kompresor sila (pri silomate)', popis: 'Iný diel — do omietačky nepatrí' },
]
const RATE_UNITS = [
  { value: '€/deň', label: '€/deň' },
  { value: '€/hod', label: '€/hod' },
  { value: '€/ks',  label: '€/ks' },
  { value: '€/m',   label: '€/m (káble/hadice)' },
  { value: '€',     label: '€ (paušál)' },
]

// ══════════════════════════════════════════════════════════════════
// HLAVNÝ KOMPONENT — master-detail stránka (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
// katalog=true → režim KATALÓG (Katalógy → Požičovňa): len položky + detail s tabmi (Mirko 2026-06-10, P1)
// katalog=false → režim POŽIČOVŇA (Majetok): len výpožičky (výdaj/príjem/doklady), „+ Nová výpožička"

// Univerzálna typ-ikona (default vizuál) per typ kusu — reálne foto per kus má prednosť (Mirko 2026-06-13)
const PART_PHOTO_BASE = '/uploads/pozicovna/'
function partPhoto(item) {
  if (item && item.photo_url) return item.photo_url
  if (item && item.thumb_url) return item.thumb_url   // fallback: prvá obrázková príloha
  // AUTO (fixná) galéria LEN pre diely čo môžu byť v ZOSTAVE — podľa KATEGÓRIE (nie názvu!).
  // (Mirko 2026-06-26: „kábel pre sondu" má kategóriu Náradie ale názov „sond" → nesmie dostať ikonu sondy.)
  const cat = ((item && item.category || '') + ' ' + (item && item.part_type || '')).toLowerCase()
  const c = (cat + ' ' + (item && item.name || '')).toLowerCase()  // s názvom len pre brand (maltech/m-tec)
  if (/silomat/.test(cat) && /maltech/.test(c)) return PART_PHOTO_BASE + 'silomat_maltech.png'
  if (/silomat/.test(cat)) return PART_PHOTO_BASE + 'silomat.png'
  if (/hru[sš]/.test(cat) && /maltech/.test(c)) return PART_PHOTO_BASE + 'hruska_maltech.png'
  if (/hru[sš]/.test(cat)) return PART_PHOTO_BASE + 'hruska.png'
  if (/omiet/.test(cat)) return PART_PHOTO_BASE + 'omietacka.png'
  if (/kapot/.test(cat)) return PART_PHOTO_BASE + 'kapota.png'
  if (/sond/.test(cat)) return PART_PHOTO_BASE + 'sonda.png'
  if (/motor/.test(cat)) return PART_PHOTO_BASE + 'motor.png'
  if (/kompres/.test(cat)) return PART_PHOTO_BASE + 'kompresor.png'
  // Lešenie (rám a pod.) NEMÁ vnútený galériový obrázok — len vlastná fotka (photo_url), inak ▦
  return null
}

// Galéria fotiek na PRIDELENIE (Mirko 2026-06-26) — user si vyberie fotku položke (zostavové diely majú auto/fixne)
const PHOTO_GALLERY = [
  ['omietacka.png', 'Omietačka'], ['ram.png', 'Rám'], ['motor.png', 'Motor'], ['kompresor.png', 'Kompresor'],
  ['silomat.png', 'Silomat m-tec'], ['silomat_maltech.png', 'Silomat maltech'],
  ['silomat_hruska.png', 'Silomat+Hruška m-tec'], ['silomat_hruska_maltech.png', 'Silomat+Hruška maltech'],
  ['hruska.png', 'Hruška m-tec'], ['hruska_maltech.png', 'Hruška maltech'],
  ['kapota.png', 'Kapota+sonda'], ['kapota_bez.png', 'Kapota (bez sondy)'], ['sonda.png', 'Sonda'],
  ['hadica_guma.png', 'Hadica guma (čierna)'], ['hadica_plast.png', 'Hadica plast'], ['hadica_voda.png', 'Hadica na vodu (PVC)'],
]
function GalleryPicker({ value, onPick }) {
  const [open, setOpen] = useState(false)
  return (
    <div>
      <BtnGhost size="sm" onClick={() => setOpen(o => !o)}>{open ? 'Skryť galériu' : 'Vybrať fotku z galérie'}</BtnGhost>
      {open && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 6, marginTop: 8 }}>
          {PHOTO_GALLERY.map(([file, lbl]) => {
            const url = PART_PHOTO_BASE + file
            const sel = value === url
            return (
              <button key={file} type="button" onClick={() => { onPick(url); setOpen(false) }}
                style={{ border: `2px solid ${sel ? COLORS.brand : COLORS.line}`, borderRadius: RADIUS.sm, background: '#fff', cursor: 'pointer', padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <img src={url} alt={lbl} style={{ width: '100%', height: 54, objectFit: 'contain' }} onError={e => { e.currentTarget.style.opacity = 0.15 }} />
                <span style={{ fontSize: 9, color: COLORS.muted, lineHeight: 1.1, textAlign: 'center' }}>{lbl}</span>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

// Miniatúra kusu v zozname — reálne foto/typ-ikona, bez lazy (spodné riadky sa inak nenačítali), fallback ▦ pri zlyhaní
function PartThumb({ row }) {
  const [err, setErr] = React.useState(false)
  const src = partPhoto(row)
  const showImg = src && !err
  return (
    <div style={{ position: 'relative', width: 56, height: 56, flexShrink: 0, borderRadius: RADIUS.sm, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {showImg
        ? <img src={src} alt="" style={{ width: '118%', height: '118%', objectFit: 'contain' }} onError={() => setErr(true)} />
        : <span style={{ fontSize: 22, color: COLORS.muted }}>▦</span>}
    </div>
  )
}

export default function ModuleTemplate({ katalog = false }) {
  const { user } = useAuth()                 // user pre LOCK (53.7)
  const toast = useToast()
  const confirm = useConfirm()
  const navigate = useNavigate()
  const [loanPicker, setLoanPicker] = useState(false)  // „+ Nová výpožička" → výber stroja
  const [qrPoolDlg, setQrPoolDlg] = useState(false)    // výroba predtlačených QR kódov (58.11)

  // ── pamäť pozície (ústava 53.3) — obnoví výber / filter / hľadanie / scroll ──
  const pos = usePositionMemory(CFG.resource)
  const listRef = useRef(null)

  const [rows, setRows]       = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch]   = useState(pos.filter?.search || '')
  const [filter, setFilter]   = useState(pos.filter?.status || 'all')
  const [catFilter, setCatFilter] = useState(pos.filter?.cat || 'all')  // lišta kategórií (Mirko 2026-06-10) — persist 53.3
  const [selectedId, setSelectedId] = useState(pos.selectedRow || null)
  const [modal, setModal]     = useState(null)  // null | {record} | {record:null}
  const [quickAction, setQuickAction] = useState(null)  // {row,type:'loan'|'return'} — požičať/vrátiť z ⋮ menu (Mirko 2026-06-10)
  const [pairAction, setPairAction] = useState(null)    // {row} — voľné párovanie (silomat+hruška, kapota+sonda) Mirko 2026-06-12
  const [mode, setMode]       = useState('pozicovna')  // 'pozicovna' | 'servis' (cudzie stroje, 58.7)
  // p58 (Mirko 18. 9. 2026: „načo je nám karta na reporty“ a „skôr podobný rozpis v požičovni, aby videl v kalendári, kde čo je“):
  // všetko je v jednom module — Zoznam (ako doteraz), Kalendár (kto čo má a dokedy) a Reporty (tlač, PDF, e-mail).
  const [sekcia, setSekcia] = useState(pos.filter?.sekcia || 'zoznam')   // 'zoznam' | 'kalendar' | 'reporty'
  const [viewMode, setViewMode] = useState(pos.filter?.view || 'stroje')   // 'stroje' | 'partaci' | 'zakazky' — zoskupenie zoznamu (Mirko 2026-06-09) — persist 53.3
  const [loans, setLoans]     = useState([])           // aktívne výpožičky — pre zoskupenie podľa parťáka/zákazky
  useEffect(() => { fetchAuth('/api/loan-records?active_only=1').then(r => r.ok ? r.json() : []).then(d => setLoans(Array.isArray(d) ? d : [])).catch(() => {}) }, [rows])
  const loanByItem = useMemo(() => { const m = {}; (loans || []).forEach(l => { m[l.item_id] = l }); return m }, [loans])

  // ── načítanie dát ────────────────────────────────────────────────
  // ticho=true → obnovenie NA POZADÍ: zoznam sa neodmontuje na „Načítavam…".
  // Mirko 30. 9. 2026: „refreshuje sa samo … každý má svoje miesto v Matrixe … nemôže Matrix sám scrolovať."
  // Prečo to skákalo: živé obnovenie (SSE) beží pri KAŽDEJ zmene v celom Matrixe, aj cudzej. Zoznam sa
  // odmontoval, pri tom sa spustil onScroll s nulou a saveScroll prepísal uloženú pozíciu nulou — a hneď
  // nato restoreScroll (useEffect na [loading] nižšie) na tú nulu človeka pretiahol. Ticho to obe zastaví:
  // zoznam zostane, onScroll s nulou nepríde, loading sa nezmení a restoreScroll sa nespustí.
  const load = useCallback(async (ticho = false) => {
    if (!ticho) setLoading(true)
    try {
      const r = await fetchAuth(CFG.apiBase)
      const d = await r.json()
      setRows(Array.isArray(d) ? d : (d.rows || []))
    } catch (_) {
      if (!ticho) toast.error('Dáta sa nenačítali.')
    } finally {
      if (!ticho) setLoading(false)
    }
  }, [toast])

  useEffect(() => { load() }, [load])
  const loadTicho = useCallback(() => load(true), [load])
  useLiveRefresh(loadTicho)  // živé obnovenie (SSE, ústava 97) — ticho, nezhodí pozíciu v zozname

  // ── filter + fulltext hľadanie (ústava sek. 56) ──────────────────
  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase()
    return rows.filter(row => {
      if ((row.parent_id || '').trim()) return false  // osadený diel — zobrazí sa v Zostave stroja (58.2.1)
      if (filter !== 'all' && effStatus(row) !== filter) return false
      if (catFilter !== 'all' && (row.category || '').trim().toLowerCase() !== catFilter.toLowerCase()) return false
      if (!q) return true
      // hľadá vo všetkých textových poliach záznamu
      return Object.values(row).some(v =>
        v != null && hladaj(String(v), q))
    }).sort((a, b) => ((a.status === 'vyradene' ? 1 : 0) - (b.status === 'vyradene' ? 1 : 0)))
  }, [rows, search, filter, catFilter])

  const selected = useMemo(
    () => rows.find(r => r.id === selectedId) || null,
    [rows, selectedId])

  // Zoskupenie zoznamu podľa zvoleného zobrazenia (Stroje = flat · Parťáci · Zákazky) — Mirko 2026-06-09
  const groupedList = useMemo(() => {
    if (viewMode === 'stroje') return [{ key: '_all', header: null, items: filtered }]
    const keyOf = (r) => {
      const l = loanByItem[r.id]
      if (viewMode === 'partaci') return (l && l.employee_name) ? l.employee_name : '— nepožičané —'
      return (l && (l.project_name || l.project_id)) ? ((l.project_id ? l.project_id + ' · ' : '') + (l.project_name || '')) : '— bez zákazky / nepožičané —'
    }
    const map = {}
    filtered.forEach(r => { const k = keyOf(r); (map[k] = map[k] || []).push(r) })
    return Object.keys(map).sort((a, b) => a.startsWith('—') ? 1 : b.startsWith('—') ? -1 : a.localeCompare(b, 'sk'))
      .map(k => ({ key: k, header: k, items: map[k] }))
  }, [viewMode, filtered, loanByItem])

  // ── pamäť pozície — zápis zmien (ústava 53.3) ────────────────────
  useEffect(() => { pos.selectRow(selectedId) }, [selectedId, pos.selectRow])
  useEffect(() => { pos.setFilter({ status: filter, search, cat: catFilter, view: viewMode, sekcia }) }, [filter, search, catFilter, viewMode, sekcia, pos.setFilter])
  useEffect(() => {
    if (!loading && listRef.current) pos.restoreScroll(listRef.current)
  }, [loading])  // eslint-disable-line react-hooks/exhaustive-deps

  // ── klávesová navigácia zoznamu (ústava 54.2, 56.5) — zdieľaný hook ──
  const openRecord = useCallback((row) => setModal({ record: row }), [])
  useListKeyboard({
    items: filtered,
    selectedId,
    onSelect: setSelectedId,
    onOpen: openRecord,
    enabled: !modal,
  })

  // ── klávesové skratky (ústava sek. 54) ───────────────────────────
  useShortcuts([
    { keys: 'alt+n', label: CFG.newLabel, scope: CFG.resource,
      handler: () => setModal({ record: null, defaultCat: catFilter !== 'all' ? catFilter : '' }) },
    { keys: '/', label: 'Hľadať', scope: CFG.resource, handler: () => {
      const el = document.querySelector(`[data-${CFG.resource}-search]`)
      if (el) el.focus()
    } },
  ])

  // ── KPI súhrn (ústava sek. 56.8) ─────────────────────────────────
  const kpi = useMemo(() => ({
    total:  rows.length,
    active: rows.filter(r => r.status === 'active').length,
  }), [rows])

  const segStyle = (on) => ({ padding: '7px 14px', borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: 'pointer', border: `1.5px solid ${on ? COLORS.brand : COLORS.line}`, background: on ? COLORS.brand : COLORS.bg, color: on ? '#fff' : COLORS.muted, fontFamily: 'inherit' })
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      {/* TOP ROW — prepínač režimu + akcie v jednom riadku (ústava 92.6) */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: SPACE.sm, flexWrap: 'wrap', flexShrink: 0 }}>
        {katalog
          ? <div style={{ fontWeight: 800, fontSize: 15, color: COLORS.nav }}>Katalóg strojov a náradia</div>
          : <>
              <button onClick={() => setMode('pozicovna')} style={segStyle(mode === 'pozicovna')}>Požičovňa (výpožičky)</button>
              <button onClick={() => setMode('servis')} style={segStyle(mode === 'servis')}>Servis cudzích strojov</button>
            </>}
        <div style={{ flex: 1 }} />
        {(katalog || mode === 'pozicovna') && <>
          <ExportMenu data={filtered} filename={`pozicovna-${todayLocal()}`} title="Pozicovna"
            columns={[{ key: 'id', label: 'ID' }, { key: 'code', label: 'Kód' }, { key: 'name', label: 'Názov' }, { key: 'category', label: 'Kategória' }, { key: 'rate', label: 'Sadzba' }, { key: 'rate_unit', label: 'MJ' }, { key: 'status', label: 'Stav' }]} />
          {katalog && <Btn variant="nav" onClick={() => setQrPoolDlg(true)}>QR výroba</Btn>}
          {katalog
            ? <BtnAdd onClick={() => setModal({ record: null, defaultCat: catFilter !== 'all' ? catFilter : '' })}>+ Nová položka</BtnAdd>
            : <BtnAdd onClick={() => setLoanPicker(true)}>+ Nová výpožička</BtnAdd>}
        </>}
      </div>
      {(!katalog && mode === 'servis') ? <ServisCudzich /> : <>
      {!katalog && (
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: SPACE.sm, flexShrink: 0, flexWrap: 'wrap' }}>
          {[{ k: 'zoznam', t: 'Zoznam' }, { k: 'kalendar', t: 'Kalendár' }, { k: 'reporty', t: 'Reporty' }].map(s => {
            const on = sekcia === s.k
            return (
              <button key={s.k} onClick={() => setSekcia(s.k)}
                style={{ padding: '6px 16px', fontSize: TYPO.sizes.sm, fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer',
                  borderRadius: RADIUS.md, color: on ? '#fff' : COLORS.nav, background: on ? COLORS.nav : COLORS.bg,
                  border: `1px solid ${on ? COLORS.nav : COLORS.line}` }}>{s.t}</button>
            )
          })}
          <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginLeft: SPACE.sm }}>
            {sekcia === 'kalendar' ? 'Riadok = stroj, stĺpec = deň. Červený pruh je po plánovanom návrate.'
              : sekcia === 'reporty' ? 'Filtre platía aj pre tlač, PDF a e-mail.'
              : 'Náradie, výdaj a vrátenie.'}
          </span>
        </div>
      )}
      {!katalog && sekcia === 'kalendar' ? (
        <PozicovnaKalendar polozky={rows} onOtvorPolozku={(id) => { setSelectedId(id); setSekcia('zoznam') }} />
      ) : !katalog && sekcia === 'reporty' ? (
        <PozicovnaReporty vnorene />
      ) : <>
      {/* STAV — horizontálny filter pás (ústava 90; plný text, neorezané) */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', padding: '6px 10px', background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, marginBottom: SPACE.sm, flexShrink: 0 }}>
        <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: 700 }}>Stav:</span>
        {STATUS_FILTERS.map(o => { const on = filter === o.key; const c = o.color || COLORS.muted; return <button key={o.key} onClick={() => setFilter(o.key)} style={{ padding: '3px 11px', fontSize: TYPO.sizes.xs, fontWeight: 600, borderRadius: RADIUS.full, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap', color: on ? '#fff' : c, background: on ? c : 'transparent', border: `1px solid ${c}` }}>{o.label}</button> })}
      </div>
      {/* KATEGÓRIA — horizontálny filter pás (Mirko 2026-06-10) */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', padding: '6px 10px', background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, marginBottom: SPACE.sm, flexShrink: 0 }}>
        <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: 700 }}>Kategória:</span>
        {[{ key: 'all', label: 'Všetko' }, ...CATEGORY_BAR.map(c => ({ key: c, label: c }))].map(o => { const on = catFilter === o.key; const c = COLORS.brand; return <button key={o.key} onClick={() => setCatFilter(o.key)} style={{ padding: '3px 11px', fontSize: TYPO.sizes.xs, fontWeight: 600, borderRadius: RADIUS.full, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap', color: on ? '#fff' : c, background: on ? c : 'transparent', border: `1px solid ${c}` }}>{o.label}</button> })}
      </div>
      {/* WIDGET VOĽNÉ STROJE — počty per kategória (P3, Mirko 2026-06-10) */}
      {!katalog && <AvailabilityWidget rows={rows} onPick={(cat) => setCatFilter(cat)} />}
      <MasterDetail
        leftWidth={320}
        left={
          <>
            <SearchInput value={search} onChange={setSearch}
              dataAttr={`data-${CFG.resource}-search`}
              placeholder="Hľadať (stlač /)…" />
            {/* PREPÍNAČ ZOBRAZENIA — Stroje / Parťáci / Zákazky (len výpožičky; v katalógu nie) */}
            {!katalog && (
            <div style={{ display: 'flex', gap: 6, padding: '8px 8px 2px' }}>
              {[{ k: 'stroje', ic: 'pozicovna', t: 'Stroje' }, { k: 'partaci', ic: 'partie', t: 'Parťáci' }, { k: 'zakazky', ic: 'zakazky', t: 'Zákazky' }].map(v => { const on = viewMode === v.k; return <button key={v.k} onClick={() => setViewMode(v.k)} style={{ flex: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 5, padding: '6px 8px', fontSize: TYPO.sizes.xs, fontWeight: 700, borderRadius: RADIUS.md, cursor: 'pointer', fontFamily: 'inherit', color: on ? '#fff' : COLORS.muted, background: on ? COLORS.brand : COLORS.bg, border: `1px solid ${on ? COLORS.brand : COLORS.line}` }}><NavIcon name={v.ic} size={15} /> {v.t}</button> })}
            </div>
            )}
            <div ref={listRef}
              onScroll={e => pos.saveScroll(e.currentTarget.scrollLeft, e.currentTarget.scrollTop)}
              style={{ flex: 1, overflow: 'auto', padding: 6 }}>
              {loading ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  Načítavam…
                </div>
              ) : filtered.length === 0 ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  {rows.length > 0 ? (
                    <>
                      <div>Žiadne záznamy pre zvolený filter — <strong>{rows.length}</strong> {rows.length === 1 ? 'položka je skrytá' : (rows.length < 5 ? 'položky sú skryté' : 'položiek je skrytých')} (napr. stroje v stave <em>Požičané</em>).</div>
                      <button onClick={() => { setFilter('all'); setCatFilter('all'); setSearch('') }} style={{ marginTop: 10, padding: '5px 12px', fontSize: TYPO.sizes.xs, fontWeight: 700, borderRadius: RADIUS.full, cursor: 'pointer', fontFamily: 'inherit', color: '#fff', background: COLORS.brand, border: 'none' }}>Zobraziť všetko</button>
                    </>
                  ) : 'Žiadne záznamy.'}
                </div>
              ) : groupedList.map(g => (
                <React.Fragment key={g.key}>
                  {g.header && <div style={{ position: 'sticky', top: 0, zIndex: 1, background: COLORS.bgSoft, borderBottom: `1px solid ${COLORS.line}`, padding: '5px 8px', fontSize: TYPO.sizes.xs, fontWeight: 800, color: COLORS.nav, textTransform: 'uppercase', letterSpacing: '.03em' }}>{g.header} <span style={{ color: COLORS.muted, fontWeight: 600 }}>({g.items.length})</span></div>}
                  {g.items.map(row => (
                    <ListRow key={row.id}
                      dataId={row.id}
                      selected={row.id === selectedId}
                      onClick={() => setSelectedId(row.id)}
                      onDoubleClick={() => setModal({ record: row })}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, opacity: row.status === 'vyradene' ? 0.4 : 1 }}>
                        {/* stlpce_v1 (Mirko 15. 10. 2026: „opravene lave stlpce okamzite teraz"):
                            nazov aj popis mali nowrap + ellipsis, takze sa OREZALI namiesto zalomenia —
                            rovnaka chyba ako v Zamestnancoch („Jana …", „Marek H…"). */}
                        <PartThumb row={row} />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, minWidth: 0 }}>
                            <span style={{ fontWeight: TYPO.weights.semibold, color: COLORS.text, whiteSpace: 'normal', wordBreak: 'break-word', flex: 1, minWidth: 0 }}>{row.name || '(bez názvu)'}</span>
                            {(fmtCode(row.code) && !(row.name || '').includes(fmtCode(row.code))) ? <span style={{ color: COLORS.brand, fontWeight: 800, whiteSpace: 'nowrap', flexShrink: 0 }}>{fmtCode(row.code)}</span> : null}
                          </div>
                          {row.description ? <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.text, marginTop: 1, whiteSpace: 'normal', wordBreak: 'break-word' }}>{row.description}</div> : null}
                          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono, marginTop: 2 }}>
                            {row.category || (fmtCode(row.code) ? '' : row.id)}{row.rate ? (row.category ? ' · ' : '') + Number(row.rate).toFixed(2) + ' ' + (row.rate_unit || '€') : ''}
                          </div>
                          {(() => { const l = loanByItem[row.id]; return l ? <div style={{ fontSize: 10, fontWeight: 700, marginTop: 2, color: l.term === 'rocne' ? '#7c3aed' : '#0369a1' }}>{l.term === 'rocne' ? '◆ ROČNÉ' : '◆ ZÁKAZKA'}{l.employee_name ? ' · ' + l.employee_name : ''}{l.project_id ? ' · ' + l.project_id : ''}</div> : null })()}
                          {row.pair_id ? <div style={{ fontSize: 10, fontWeight: 700, marginTop: 2, color: '#0369a1' }}>pár · {(rows.find(x => x.id === row.pair_id) || {}).code || row.pair_id}</div> : null}
                          {(row.uid || '').trim() ? <div style={{ fontSize: 10, fontWeight: 700, marginTop: 2, color: COLORS.muted, fontFamily: TYPO.mono, letterSpacing: '.06em' }}>QR {row.uid}</div> : null}
                        </div>
                        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                          <StatusTag status={effStatus(row)} />
                          <RowMenu actions={katalog ? [
                            { key: 'edit', label: 'Upraviť', onClick: () => setModal({ record: row }) },
                            { key: 'dup', label: 'Duplikovať', icon: '⧉', onClick: async () => {
                              try {
                                const r = await fetchAuth(`/api/loan-items/${row.id}/duplicate`, { method: 'POST' })
                                if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Duplikovanie zlyhalo') }
                                const created = await r.json()
                                toast.success('Duplikované (aj s fotkou) — uprav kópiu'); load(); setModal({ record: created })
                              } catch (e) { toast.error('Chyba: ' + e.message) }
                            } },
                            { separator: true },
                            { key: 'del', label: 'Vyradiť', danger: true, onClick: async () => {
                              const ok = await confirm({ title: 'Vyradiť položku?', message: `Naozaj vyradiť položku ${row.id}${row.name ? ' (' + row.name + ')' : ''}?`, danger: true, confirmLabel: 'Vyradiť' })
                              if (!ok) return
                              try { const r = await fetchAuth(`/api/loan-items/${row.id}`, { method: 'DELETE' }); if (!r.ok) throw new Error('DELETE zlyhal'); toast.success('Vyradené'); load() } catch (e) { toast.error('Chyba: ' + e.message) }
                            } },
                          ] : [
                            { key: 'detail', label: 'Detail stroja', icon: '↗', onClick: () => { setSelectedId(row.id); pos.selectRow(row.id); navigate('/katalog/pozicovna') } },
                            { key: 'loan', label: effStatus(row) === 'pozicane' ? 'Vrátiť' : 'Vypožičať', icon: '↔', onClick: () => { setSelectedId(row.id); if (effStatus(row) === 'dostupne') setQuickAction({ row, type: 'loan' }); else if (effStatus(row) === 'pozicane') setQuickAction({ row, type: 'return' }); else toast.error('Stroj je ' + (STATUS_LABEL[effStatus(row)] || effStatus(row)) + ' — nedá sa požičať/vrátiť') } },
                            row.pair_id
                              ? { key: 'unpair', label: 'Rozpárovať', icon: '', onClick: async () => { try { const r = await fetchAuth(`/api/loan-items/${row.id}/unpair`, { method: 'POST' }); if (!r.ok) throw new Error('zlyhalo'); toast.success('Rozpárované'); load() } catch (e) { toast.error('Chyba: ' + e.message) } } }
                              : { key: 'pair', label: 'Spárovať s…', icon: '', onClick: () => setPairAction({ row }) },
                            { separator: true },
                            { key: 'servis', label: row.status === 'v_servise' ? 'Vrátiť zo servisu (→ Dostupné)' : 'Dať na servis (porucha)', danger: row.status !== 'v_servise', onClick: async () => {
                              const ns = row.status === 'v_servise' ? 'dostupne' : 'v_servise'
                              try { const r = await fetchAuth(`/api/loan-items/${row.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...row, status: ns }) }); if (!r.ok) throw new Error('PUT zlyhal'); toast.success(ns === 'v_servise' ? 'Označené: V servise (porucha)' : 'Vrátené zo servisu → Dostupné'); load() } catch (e) { toast.error('Chyba: ' + e.message) }
                            } },
                          ]} />
                        </div>
                      </div>
                    </ListRow>
                  ))}
                </React.Fragment>
              ))}
            </div>
            <ListStatusBar>
              ↑↓ výber · Enter detail · Alt+N nový · / hľadať
            </ListStatusBar>
          </>
        }
        right={
          selected
            ? <DetailPane record={selected} katalog={katalog} navigate={navigate} onEdit={() => setModal({ record: selected })} onReload={load} onAfterLoan={() => { setFilter('all'); load() }} />
            : <EmptyPane text="Vyber záznam zo zoznamu vľavo" />
        }
      />
      </>}

      {modal && (
        <RecordModal
          open
          record={modal.record}
          defaultCat={modal.defaultCat}
          user={user}
          onClose={() => setModal(null)}
          onSaved={() => {
            setModal(null)
            load()
            toast.success('Uložené.')
          }}
          onReload={load}
        />
      )}
      {quickAction && quickAction.type === 'loan' && (
        <LoanDialog item={quickAction.row}
          onClose={() => setQuickAction(null)}
          onDone={() => { setQuickAction(null); setFilter('all'); load() }} />
      )}
      {quickAction && quickAction.type === 'return' && (
        <ReturnDialog item={quickAction.row}
          onClose={() => setQuickAction(null)}
          onDone={() => { setQuickAction(null); setFilter('all'); load() }} />
      )}
      {pairAction && (
        <PairDialog item={pairAction.row} allItems={rows}
          onClose={() => setPairAction(null)}
          onDone={() => { setPairAction(null); load() }} />
      )}
      {loanPicker && (
        <LoanPicker
          items={(rows || []).filter(r => effStatus(r) === 'dostupne')}
          onClose={() => setLoanPicker(false)}
          onPick={(row) => { setLoanPicker(false); setSelectedId(row.id); setQuickAction({ row, type: 'loan' }) }}
        />
      )}
      {qrPoolDlg && <QrPoolDialog onClose={() => setQrPoolDlg(false)} />}
      </>}
    </div>
  )
}

// ── LoanPicker — „+ Nová výpožička": výber dostupného stroja → LoanDialog (Mirko 2026-06-10, P1) ──
function LoanPicker({ items, onClose, onPick }) {
  const [q, setQ] = useState('')
  const list = useMemo(() => {
    const s = q.trim().toLowerCase()
    return (items || []).filter(it => !s || hladaj(((it.name || '') + ' ' + (it.code || '') + ' ' + (it.category || '')), s))
  }, [items, q])
  return (
    <Modal open title="Nová výpožička — vyber stroj" onClose={onClose} width={560}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
        <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>Zobrazené sú len <strong>dostupné</strong> stroje. Stroje sa zakladajú v Katalógy → Požičovňa.</div>
        <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Hľadať stroj…"
          style={{ ...inputStyle }} />
        <div style={{ maxHeight: 360, overflow: 'auto', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md }}>
          {list.length === 0 ? (
            <div style={{ padding: SPACE.md, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Žiadny dostupný stroj.</div>
          ) : list.map(it => (
            <button key={it.id} onClick={() => onPick(it)} style={{ display: 'flex', width: '100%', textAlign: 'left', alignItems: 'center', gap: 10, padding: '9px 12px', border: 'none', borderBottom: `1px solid ${COLORS.lineSoft}`, background: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, color: COLORS.text }}>{it.name}</div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{it.code || it.id}{it.category ? ' · ' + it.category : ''}</div>
              </div>
              <StatusTag status={it.status} />
            </button>
          ))}
        </div>
      </div>
    </Modal>
  )
}

// ══════════════════════════════════════════════════════════════════
// STATUS TAG — farebný štítok stavu (ústava 21.15 — z TINT, nie inline)
// ══════════════════════════════════════════════════════════════════
function StatusTag({ status }) {
  const isActive = status === 'active'
  return (
    <span style={{
      fontSize: TYPO.sizes.xs,
      fontWeight: TYPO.weights.semibold,
      color: isActive ? COLORS.add : COLORS.muted,
      background: isActive ? TINT.add : COLORS.lineSoft,
      borderRadius: RADIUS.sm,
      padding: '1px 7px',
    }}>{STATUS_LABEL[status] || status || '—'}</span>
  )
}

// ══════════════════════════════════════════════════════════════════
// DETAIL PANE — pravá strana, taby Detail / História (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
// ── LoanDialog (vypožičať — ústava 58.3/58.4) ──────────────────────────────
// ── AvailabilityWidget — počty VOĽNÝCH strojov per kategória (P3, Mirko 2026-06-10) ──
function AvailabilityWidget({ rows, onPick }) {
  const stats = useMemo(() => {
    const map = {}
    ;(rows || []).filter(r => r.active !== 0 && r.status !== 'vyradene' && !(r.parent_id || '').trim()).forEach(r => {
      const cat = ((r.category || '').trim()) || 'Iné'
      if (!map[cat]) map[cat] = { total: 0, free: 0, loaned: 0, servis: 0 }
      const m = map[cat]; m.total++
      if (effStatus(r) === 'dostupne') m.free++
      else if (effStatus(r) === 'pozicane') m.loaned++
      else if (r.status === 'v_servise') m.servis++
    })
    const order = (k) => { const i = CATEGORY_BAR.findIndex(c => c.toLowerCase() === k.toLowerCase()); return i < 0 ? 99 : i }
    return Object.keys(map).sort((a, b) => order(a) - order(b) || a.localeCompare(b, 'sk')).map(k => ({ cat: k, ...map[k] }))
  }, [rows])
  if (!stats.length) return null
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'stretch', marginBottom: SPACE.sm, flexShrink: 0 }}>
      {stats.map(s => {
        const c = s.free > 0 ? COLORS.add : COLORS.muted
        return (
          <button key={s.cat} onClick={() => onPick && onPick(s.cat)}
            title={`${s.cat}: ${s.free} voľných · ${s.loaned} požičané · ${s.servis} v servise · spolu ${s.total}`}
            style={{ flex: '1 1 130px', minWidth: 118, textAlign: 'left', border: `1px solid ${COLORS.line}`, borderLeft: `4px solid ${c}`, borderRadius: RADIUS.md, background: '#fff', padding: '7px 11px', cursor: 'pointer', fontFamily: 'inherit' }}>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.03em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.cat}</div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 5, marginTop: 2 }}>
              <span style={{ fontSize: 20, fontWeight: 800, color: c }}>{s.free}</span>
              <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>voľné / {s.total}</span>
            </div>
            {(s.loaned > 0 || s.servis > 0) && <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 1 }}>{s.loaned > 0 ? `${s.loaned} požič.` : ''}{s.loaned > 0 && s.servis > 0 ? ' · ' : ''}{s.servis > 0 ? `${s.servis} servis` : ''}</div>}
          </button>
        )
      })}
    </div>
  )
}

// ── PhotoCapture — foto PRED/PO výpožičke (P2, Mirko 2026-06-10; mobil = fotoaparát) ──
function PhotoCapture({ label, value, onChange, hint }) {
  const [up, setUp] = useState(false)
  const toast = useToast()
  const handle = async (e) => {
    const f = e.target.files && e.target.files[0]; if (!f) return
    setUp(true)
    try {
      const fd = new FormData(); fd.append('file', f)
      const r = await fetchAuth('/api/loan-photo', { method: 'POST', body: fd })
      if (!r.ok) throw new Error('upload')
      const d = await r.json()
      onChange(d.url)
    } catch (_) { toast.error('Foto sa nenahralo') } finally { setUp(false); e.target.value = '' }
  }
  return (
    <Field label={label}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {value
          ? <img src={value} alt="" style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 6, border: `1px solid ${COLORS.line}` }} />
          : <div style={{ width: 64, height: 64, borderRadius: 6, border: `1px dashed ${COLORS.line}`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: COLORS.muted, fontSize: 10 }}>bez foto</div>}
        <label style={{ padding: '6px 12px', border: `1px solid ${COLORS.brand}`, color: COLORS.brand, borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: TYPO.sizes.xs, whiteSpace: 'nowrap' }}>
          {up ? 'Nahrávam…' : (value ? 'Zmeniť foto' : 'Odfotiť / nahrať')}
          <input type="file" accept="image/*" capture="environment" style={{ display: 'none' }} disabled={up} onChange={handle} />
        </label>
        {value && <button type="button" onClick={() => onChange('')} style={{ border: 'none', background: 'none', color: COLORS.remove, cursor: 'pointer', fontSize: TYPO.sizes.xs }}>Odstrániť</button>}
      </div>
      {hint && <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3 }}>{hint}</div>}
    </Field>
  )
}

function LoanDialog({ item, onClose, onDone }) {
  const [loanType, setLoanType] = useState('intern')
  const [term, setTerm] = useState('zakazka')  // 'rocne' (dlhodobé — omietačky, dec. inventúra) | 'zakazka' (na zákazku)
  const [employees, setEmployees] = useState([])
  const [projects, setProjects] = useState([])
  const [customers, setCustomers] = useState([])
  const [empId, setEmpId] = useState('')
  const [projId, setProjId] = useState('')
  const [custId, setCustId] = useState('')
  const [startDate, setStartDate] = useState(todayLocal())
  // p60 (19. 9. 2026): plánovaný návrat je povinný a predvyplní sa na 14 dní — podľa neho Matrix pozná, čo je po termíne.
  const [endDate, setEndDate] = useState(() => new Date(Date.now() + 14 * 86400000).toISOString().slice(0, 10))
  const [deposit, setDeposit] = useState(0)
  const [rateUsed, setRateUsed] = useState(item?.rate || 0)
  const [rateUnit, setRateUnit] = useState(item?.rate_unit || '€/deň')
  const [notDelivered, setNotDelivered] = useState('')
  const [notes, setNotes] = useState('')
  const [photoBefore, setPhotoBefore] = useState('')
  const [loanQty, setLoanQty] = useState(1)
  const [busy, setBusy] = useState(false)
  const toast = useToast()

  useEffect(() => {
    fetchAuth('/api/employees').then(r => r.ok ? r.json() : []).then(d => setEmployees(Array.isArray(d) ? d : (d.rows || []))).catch(() => {})
    fetchAuth('/api/projects').then(r => r.ok ? r.json() : []).then(d => setProjects(Array.isArray(d) ? d : (d.rows || []))).catch(() => {})
    fetchAuth('/api/customers').then(r => r.ok ? r.json() : []).then(d => setCustomers(Array.isArray(d) ? d : (d.rows || []))).catch(() => {})
  }, [])

  async function save() {
    if (loanType === 'intern' && !empId) { toast.error('Vyber parťáka'); return }
    if (loanType === 'intern' && !projId) { toast.error('Vyber zákazku'); return }
    if (loanType === 'extern' && !custId) { toast.error('Vyber zákazníka'); return }
    setBusy(true)
    try {
      const r = await fetchAuth('/api/loan-records', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          item_id: item.id,
          loan_type: loanType,
          term,
          qty: item.tracking === 'ks' ? Math.max(1, Number(loanQty) || 1) : 1,
          party: (employees.find(e => String(e.id) === String(empId)) || {}).party || '',
          employee_id: loanType === 'intern' ? empId : '',
          project_id:  loanType === 'intern' ? projId : '',
          customer_id: loanType === 'extern' ? custId : '',
          start_date: startDate,
          end_date: endDate,
          deposit: loanType === 'extern' ? Number(deposit) : 0,
          rate_used: loanType === 'extern' ? Number(rateUsed) : 0,
          rate_unit: rateUnit,
          not_delivered: notDelivered,
          notes,
          photo_before: photoBefore,
        }),
      })
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.message || 'Chyba pri vypožičiavaní') }
      toast.success('Položka vypožičaná — doklad vytlačíš tlačidlom „Doklad" v karte')
      if (onDone) onDone()
    } catch (e) {
      toast.error(e.message || 'Chyba pri vypožičiavaní')
    } finally {
      setBusy(false)
    }
  }

  const inputStyle = { width: '100%', padding: '6px 10px',
    border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
    fontSize: TYPO.sizes.sm, background: COLORS.bg, color: COLORS.text, boxSizing: 'border-box' }

  return (
    <Modal open={true} title={`Vypožičať — ${item.name}`} onClose={onClose} width={600}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
          <Field label="Typ výpožičky">
            <SearchableSelect value={loanType} onChange={setLoanType}
              options={[
                { value: 'intern', label: 'Interná (parťák + zákazka, zadarmo)' },
                { value: 'extern', label: 'Externá (zákazník, cenník + záloha)' },
              ]} />
          </Field>
          <Field label="Druh priradenia *">
            <SearchableSelect value={term} onChange={setTerm}
              options={[
                { value: 'zakazka', label: 'Na zákazku (krátkodobé)' },
                { value: 'rocne', label: 'Ročné / dlhodobé (omietačky — dec. inventúra)' },
              ]} />
          </Field>
        </div>
        {loanType === 'intern' ? (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
            {item.tracking === 'ks' && <Field label={'Počet ks (voľné: ' + (item.available_ks != null ? item.available_ks : (item.qty || 0)) + ')'}>
              <input type="number" min="1" max={item.available_ks != null ? item.available_ks : (item.qty || 0)} value={loanQty} onChange={e => setLoanQty(Number(e.target.value) || 1)} style={inputStyle} />
            </Field>}
            <Field label="Parťák *">
              <SearchableSelect value={empId} onChange={setEmpId}
                options={employees.filter(e => e.active && e.is_partak)
                  .map(e => ({ value: e.id, label: e.name + (e.party ? ` · ${e.party}` : '') }))}
                placeholder="Vyber parťáka…" />
            </Field>
            <Field label="Zákazka *">
              <SearchableSelect value={projId} onChange={setProjId}
                options={projects.filter(p => p.status === 'active' || p.status === 'planned')
                  .map(p => ({ value: p.id, label: p.id + ' · ' + (p.name || '—') }))}
                placeholder="Vyber zákazku…" />
            </Field>
          </div>
        ) : (
          <Field label="Zákazník (partner) *">
            <SearchableSelect value={custId} onChange={setCustId}
              options={customers.map(c => ({ value: c.id, label: c.name }))}
              placeholder="Vyber zákazníka…" />
          </Field>
        )}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
          <Field label="Od *">
            <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={inputStyle} />
          </Field>
          <Field label="Plánovaný návrat *">
            <input type="date" value={endDate} min={startDate || undefined} onChange={e => setEndDate(e.target.value)} style={inputStyle} />
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 3 }}>Podľa neho Matrix pozná, čo je po termíne.</div>
          </Field>
        </div>
        {loanType === 'extern' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.md }}>
            <Field label="Sadzba">
              <input type="number" step="0.01" value={rateUsed} onChange={e => setRateUsed(Number(e.target.value) || 0)} style={inputStyle} />
            </Field>
            <Field label="Jednotka">
              <SearchableSelect value={rateUnit} onChange={setRateUnit} options={RATE_UNITS} />
            </Field>
            <Field label="Záloha / depozit *">
              <input type="number" step="0.01" value={deposit} onChange={e => setDeposit(Number(e.target.value) || 0)} style={inputStyle} />
            </Field>
          </div>
        )}
        <Field label="Čo sa nevydalo (ústava 58.2)">
          <input type="text" value={notDelivered} onChange={e => setNotDelivered(e.target.value)}
            placeholder="napr. hadica 10m chýba, manuál chýba…" style={inputStyle} />
        </Field>
        <Field label="Poznámka">
          <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={2}
            style={{ ...inputStyle, resize: 'vertical' }} />
        </Field>
        <PhotoCapture label="Foto PRED výpožičkou (stav stroja)" value={photoBefore} onChange={setPhotoBefore}
          hint="Odfoť stav stroja pri výdaji — anti-spor. Na mobile sa otvorí fotoaparát." />
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost>
          <BtnAdd onClick={save} disabled={busy}>{busy ? 'Ukladám…' : 'Vypožičať'}</BtnAdd>
        </div>
      </div>
    </Modal>
  )
}

// ── ReturnDialog (vrátiť — ústava 58.5) ────────────────────────────────────
// PairDialog — voľné párovanie kusov (silomat+hruška, kapota+sonda) — Mirko 2026-06-12
function PairDialog({ item, allItems, onClose, onDone }) {
  const [partnerId, setPartnerId] = useState('')
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  const candidates = (allItems || [])
    .filter(x => x.id !== item.id && !x.pair_id && x.status !== 'vyradene')
    .map(x => ({ value: x.id, label: `${x.name || ''} ${x.code || x.id}`.trim() }))
  async function save() {
    if (!partnerId) { toast.error('Vyber kus na spárovanie'); return }
    setBusy(true)
    try {
      const r = await fetchAuth('/api/loan-items/pair', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id_a: item.id, id_b: partnerId }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(j.error || 'zlyhalo')
      toast.success('Spárované')
      if (onDone) onDone()
    } catch (e) { toast.error('Chyba: ' + e.message) } finally { setBusy(false) }
  }
  return (
    <Modal open={true} title={`Spárovať — ${item.name || item.id}`} onClose={onClose} width={460}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>Voľný pár (napr. silomat + hruška, kapota + sonda). Požičiavajú a vracajú sa spolu; dá sa rozpárovať.</div>
        <div>
          <div style={{ fontSize: TYPO.sizes.xs, fontWeight: 700, marginBottom: 4, color: COLORS.muted }}>Spárovať s kusom</div>
          <SearchableSelect value={partnerId} onChange={setPartnerId} options={candidates} placeholder="vyber kus…" />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: SPACE.sm }}>
          <BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost>
          <BtnAdd onClick={save} disabled={busy || !partnerId}>{busy ? 'Párujem…' : 'Spárovať'}</BtnAdd>
        </div>
      </div>
    </Modal>
  )
}

function ReturnDialog({ item, onClose, onDone }) {
  const [activeLoan, setActiveLoan] = useState(null)
  const [allLoans, setAllLoans] = useState([])
  const [retQty, setRetQty] = useState(0)
  const [components, setComponents] = useState([])
  const [verified, setVerified] = useState(() => new Set())
  const [returnDate, setReturnDate] = useState(todayLocal())
  const [damaged, setDamaged] = useState(false)
  const [returnNotes, setReturnNotes] = useState('')
  const [photoAfter, setPhotoAfter] = useState('')
  const [busy, setBusy] = useState(false)
  const toast = useToast()

  useEffect(() => {
    fetchAuth(`/api/loan-records?item_id=${item.id}&active_only=1`)
      .then(r => r.ok ? r.json() : [])
      .then(rows => { setAllLoans(rows); setActiveLoan(rows[0] || null); setRetQty((rows[0] && rows[0].qty) || 0) })
      .catch(() => {})
    if (item.tracking === 'kus') {
      fetchAuth('/api/loan-items').then(r => r.ok ? r.json() : []).then(d => setComponents((Array.isArray(d) ? d : []).filter(x => x.parent_id === item.id))).catch(() => {})
    }
  }, [item.id])

  async function save() {
    if (!activeLoan) { toast.error('Žiadna aktívna výpožička'); return }
    setBusy(true)
    try {
      const compNote = components.length
        ? '\n[58.2a kontrola výr. čísel: ' + components.map(c => `${c.name} (${c.serial_number || '?'})${verified.has(c.id) ? ' ✓' : ' NEOVERENÉ'}`).join(' · ') + ']'
        : ''
      const r = await fetchAuth(`/api/loan-records/${activeLoan.id}/return`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          return_date: returnDate,
          return_qty: item.tracking === 'ks' ? Math.max(0, Number(retQty) || 0) : undefined,
          damaged,
          return_notes: returnNotes + compNote,
          photo_after: photoAfter,
        }),
      })
      if (!r.ok) throw new Error('failed')
      toast.success(damaged ? 'Vrátené (poškodené → V servise)' : 'Vrátené')
      if (onDone) onDone()
    } catch (e) {
      toast.error('Chyba pri vrátení')
    } finally {
      setBusy(false)
    }
  }

  const inputStyle = { width: '100%', padding: '6px 10px',
    border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
    fontSize: TYPO.sizes.sm, background: COLORS.bg, color: COLORS.text, boxSizing: 'border-box' }

  return (
    <Modal open={true} title={`Vrátiť — ${item.name}`} onClose={onClose} width={520}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        {!activeLoan ? (
          <div style={{ color: COLORS.muted }}>Načítavam aktívnu výpožičku…</div>
        ) : (
          <>
            <div style={{ padding: SPACE.md, background: COLORS.bgSoft,
              border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md }}>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Aktuálne požičané</div>
              <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold }}>
                {activeLoan.loan_type === 'intern'
                  ? `${activeLoan.employee_name || activeLoan.employee_id} · ${activeLoan.project_id || ''}`
                  : `${activeLoan.customer_name || activeLoan.customer_id}`}
              </div>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2 }}>
                Od {activeLoan.start_date}
                {activeLoan.end_date && ` · plánovaný návrat ${activeLoan.end_date}`}
              </div>
            </div>
            {item.tracking === 'kus' && components.length > 0 && (
              <div style={{ border: `1px solid ${COLORS.warn}`, borderRadius: RADIUS.md, padding: SPACE.sm, background: 'rgba(245,158,11,0.06)' }}>
                <div style={{ fontSize: TYPO.sizes.xs, fontWeight: 700, color: '#92400e', marginBottom: 6 }}>Skontroluj osadené komponenty — výrobné čísla (ústava 58.2a)</div>
                {components.map(c => (
                  <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '3px 0', cursor: 'pointer', fontSize: TYPO.sizes.sm }}>
                    <input type="checkbox" checked={verified.has(c.id)} onChange={e => setVerified(s => { const n = new Set(s); e.target.checked ? n.add(c.id) : n.delete(c.id); return n })} />
                    <span style={{ flex: 1, minWidth: 0 }}>{c.name}</span>
                    <span style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>č. {c.serial_number || '?'}</span>
                  </label>
                ))}
                <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 4 }}>Zaškrtni len tie, ktoré fyzicky sedia. Nezaškrtnuté = možná nenahlásená výmena (zapíše sa do poznámky vrátenia).</div>
              </div>
            )}
            {item.tracking === 'ks' && <>
              {allLoans.length > 1 && <Field label="Ktorá výpožička (partia)">
                <SearchableSelect value={activeLoan ? activeLoan.id : ''} onChange={v => { const l = allLoans.find(x => x.id === v); setActiveLoan(l || null); setRetQty((l && l.qty) || 0) }} options={allLoans.map(l => ({ value: l.id, label: (l.party || l.employee_name || '?') + ' · ' + l.qty + ' ks' + (l.project_id ? ' · ' + l.project_id : '') }))} />
              </Field>}
              <Field label={'Vrátiť počet ks (z ' + (activeLoan ? activeLoan.qty : 0) + ')'}>
                <input type="number" min="0" max={activeLoan ? activeLoan.qty : 0} value={retQty} onChange={e => setRetQty(Number(e.target.value) || 0)} style={inputStyle} />
              </Field>
            </>}
            <Field label="Dátum vrátenia *">
              <input type="date" value={returnDate} onChange={e => setReturnDate(e.target.value)} style={inputStyle} />
            </Field>
            <label style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm,
              padding: SPACE.sm, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
              background: damaged ? 'rgba(239,68,68,0.08)' : 'transparent', cursor: 'pointer' }}>
              <input type="checkbox" checked={damaged} onChange={e => setDamaged(e.target.checked)} />
              <span style={{ fontSize: TYPO.sizes.sm, color: damaged ? COLORS.remove : COLORS.text }}>
                Vrátené poškodené (→ status položky V servise)
              </span>
            </label>
            <Field label="Poznámka k vráteniu">
              <textarea value={returnNotes} onChange={e => setReturnNotes(e.target.value)} rows={2}
                placeholder="napr. chýba kľúč, opotrebovaný motor, doúčtovanie…"
                style={{ ...inputStyle, resize: 'vertical' }} />
            </Field>
            <PhotoCapture label="Foto PO vrátení (stav stroja)" value={photoAfter} onChange={setPhotoAfter}
              hint="Odfoť stav stroja pri vrátení — porovnanie s foto pred. Na mobile fotoaparát." />
          </>
        )}
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost>
          <BtnAdd onClick={save} disabled={busy || !activeLoan}>{busy ? 'Ukladám…' : 'Vrátiť'}</BtnAdd>
        </div>
      </div>
    </Modal>
  )
}

// ── PREDTLAČENÉ QR KÓDY — výroba nálepiek (ústava 58.11, Mirko 2026-08-27) ────
// Pool unikátnych 6-znakových kódov → hárok A4 (4×7 nálepiek 50×40 mm) → výroba
// nálepiek vo firme → nalepiť na náradie → priradiť položke (sken alebo katalóg).
// QR sa kreslí lokálne ako vektor (qrcode-generator, ECC H) s priehľadným pozadím,
// takže vodoznak KAMIR presvitá aj pod samotným QR kódom. Bez externej služby.
const QR_INK = '#2f363d'  // slate z KAMIR loga — moduly QR
function qrSvgStr(payload, color = QR_INK) {
  const qr = qrcodegen(0, 'H')
  qr.addData(payload)
  qr.make()
  const n = qr.getModuleCount()
  let d = ''
  for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) d += `M${c} ${r}h1v1h-1z`
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${n} ${n}" shape-rendering="crispEdges" preserveAspectRatio="xMidYMid meet"><path fill="${color}" d="${d}"/></svg>`
}
// mode 'labels' = jedna nálepka na stranu, presne 50×40 mm, BEZ rezných čiar → podklad pre tlačiareň.
// mode 'sheet'  = hárok A4 (4×7) s reznými čiarami → keď si niekto reže sám.
const LABEL_CSS = `
.lab{position:relative;width:50mm;height:40mm;overflow:hidden;background:#fff;display:flex;flex-direction:column;padding:2mm 2.6mm 1.7mm}
.wm{position:absolute;left:-3mm;top:14mm;width:56mm;opacity:.055;transform:rotate(-12deg);pointer-events:none}
.hd{position:relative;display:flex;align-items:center;justify-content:space-between}
.lg{height:4mm;max-width:24mm;object-fit:contain;object-position:left center}
.hdt{font-size:5.4pt;font-weight:800;letter-spacing:.18em;color:#3b4249}
.hdbar{position:relative;height:0.5mm;background:linear-gradient(90deg,#f7a447,#e8751a);border-radius:1mm;margin-top:0.9mm}
.bd{flex:1;display:flex;align-items:center;gap:2.2mm;position:relative;padding-top:0.9mm}
.qr{width:22.5mm;height:22.5mm;flex-shrink:0}
.qr svg{width:100%;height:100%;display:block}
.side{flex:1;text-align:center;min-width:0;position:relative}
.cg{font-family:Consolas,'Courier New',monospace;font-weight:700;font-size:14pt;line-height:1.05;color:#2f363d;letter-spacing:0.5mm}
.rule{height:0.35mm;width:7mm;background:linear-gradient(90deg,#f7a447,#e8751a);margin:0.9mm auto;border-radius:1mm}
.web{font-size:4.8pt;color:#8a8479;margin-top:1.3mm;letter-spacing:.14em;text-transform:uppercase}
.ft{position:relative;display:flex;justify-content:space-between;align-items:center;font-size:4.6pt;color:#8a8479;border-top:0.2mm solid #e7e2db;padding-top:0.7mm}
.fc{font-family:Consolas,'Courier New',monospace;font-weight:700;color:#e8751a;font-size:5pt;letter-spacing:.08em}`
function qrLabelHtml(code, base, logoUrl, esc) {
  return `<div class="lab">
      <img class="wm" src="${esc(logoUrl)}" onerror="this.style.display='none'">
      <div class="hd"><img class="lg" src="${esc(logoUrl)}" onerror="this.style.display='none'"><span class="hdt">POŽIČOVŇA</span></div>
      <div class="hdbar"></div>
      <div class="bd">
        <div class="qr">${qrSvgStr(`${base}/v2/qr/${code}`)}</div>
        <div class="side"><div class="cg">${esc(code.slice(0, 3))}</div><div class="rule"></div><div class="cg">${esc(code.slice(3))}</div><div class="web">kamir.sk</div></div>
      </div>
      <div class="ft"><span>Majetok KAMIR s.r.o.</span><span class="fc">${esc(code)}</span></div>
    </div>`
}
function qrPoolSheetHtml(codes, base, logoUrl, batchLabel, opts = {}) {
  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  const mode = opts.mode === 'sheet' ? 'sheet' : 'labels'
  const forPdf = !!opts.forPdf
  const title = `KAMIR-QR-nalepky${batchLabel ? '-' + esc(batchLabel) : ''}-${codes.length}ks`
  const labs = codes.map(c => qrLabelHtml(c, base, logoUrl, esc))
  let body, css
  if (mode === 'labels') {
    body = labs.map(l => `<div class="pg">${l}</div>`).join('')
    css = `@page{size:50mm 40mm;margin:0}
.pg{width:50mm;height:40mm;page-break-after:always;break-after:page;overflow:hidden}
.pg:last-child{page-break-after:auto;break-after:auto}
body{margin:0;background:#fff}
${forPdf ? '' : 'body{background:#e9e7e3;padding:10px}.pg{margin:0 auto 6px;box-shadow:0 1px 4px rgba(0,0,0,.18)}'}`
  } else {
    const pages = []
    for (let i = 0; i < labs.length; i += 28) {
      pages.push(`<div class="page"><div class="phead"><span><b>KAMIR</b> · Požičovňa — predtlačené QR nálepky${batchLabel ? ' · ' + esc(batchLabel) : ''}</span><span>str. ${pages.length + 1} · nálepka 50 × 40 mm · rez po čiarkovanej línii</span></div><div class="grid">${labs.slice(i, i + 28).join('')}</div></div>`)
    }
    body = pages.join('')
    css = `@page{size:A4;margin:0}
.page{width:210mm;height:296mm;margin:0 auto;background:#fff;padding:4mm 5mm 0;overflow:hidden;page-break-after:always}
.page:last-child{page-break-after:auto}
.phead{display:flex;justify-content:space-between;align-items:baseline;font-size:7pt;color:#8a8479;height:4mm}
.grid{width:200mm;display:grid;grid-template-columns:repeat(4,50mm);grid-auto-rows:40mm}
.lab{outline:0.2mm dashed #c3bcb2;outline-offset:-0.1mm}
body{margin:0;background:#fff}
${forPdf ? '' : 'body{background:#e9e7e3}.page{margin-bottom:12px;box-shadow:0 1px 4px rgba(0,0,0,.14)}'}`
  }
  const toolbar = forPdf ? '' : `<div class="toolbar"><div class="hint">${mode === 'labels'
    ? `Podklad pre tlačiareň — <b>${codes.length}</b> samostatných nálepiek 50 × 40 mm, jedna na stranu, bez rezných čiar.`
    : `Hárok A4 na vlastné rezanie — <b>${codes.length}</b> nálepiek 50 × 40 mm.`} Radšej použi tlačidlo <b>„Stiahnuť PDF"</b> v Matrixe — dá presnejší súbor než tlač cez prehliadač.</div><button class="btn" onclick="window.print()">Tlačiť / Uložiť ako PDF</button></div>`
  return `<!DOCTYPE html><html lang="sk"><head><meta charset="utf-8"><title>${title}</title>
<style>*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}
body{font-family:-apple-system,'Segoe UI',Arial,sans-serif}
.toolbar{max-width:210mm;margin:0 auto 10px;display:flex;justify-content:space-between;align-items:center;gap:12px}
.btn{background:#16a34a;color:#fff;border:none;padding:9px 16px;border-radius:8px;font-weight:700;cursor:pointer;font-size:14px}
.hint{font-size:12px;color:#555;line-height:1.5}
@media print{.toolbar{display:none}body{background:#fff!important;padding:0!important}.pg,.page{box-shadow:none!important;margin:0!important}}
${LABEL_CSS}
${css}</style></head><body>
${toolbar}${body}</body></html>`
}
// Ukážka nálepky v dialógu — rovnaký dizajn ako tlačový hárok, mierka 4 px/mm
function LabelPreview({ code, logoUrl, base }) {
  const svg = useMemo(() => qrSvgStr((base || window.location.origin) + '/v2/qr/' + code), [code, base])
  const mm = 4
  return (
    <div style={{ position: 'relative', width: 50 * mm, height: 40 * mm, background: '#fff', border: '1px dashed #c3bcb2', borderRadius: 2 * mm, overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: `${1.8 * mm}px ${2.4 * mm}px ${1.5 * mm}px`, boxShadow: '0 1px 6px rgba(0,0,0,.12)', flexShrink: 0 }}>
      <img src={logoUrl} alt="" style={{ position: 'absolute', left: -3 * mm, top: 14 * mm, width: 56 * mm, opacity: .055, transform: 'rotate(-12deg)', pointerEvents: 'none' }} />
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <img src={logoUrl} alt="KAMIR" style={{ height: 4 * mm, maxWidth: 24 * mm, objectFit: 'contain', objectPosition: 'left center' }} />
        <span style={{ fontSize: 8, fontWeight: 800, letterSpacing: '.18em', color: '#3b4249' }}>POŽIČOVŇA</span>
      </div>
      <div style={{ position: 'relative', height: 2, background: 'linear-gradient(90deg,#f7a447,#e8751a)', borderRadius: 2, marginTop: .9 * mm }} />
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 2.2 * mm, position: 'relative', paddingTop: .9 * mm }}>
        <div style={{ width: 22.5 * mm, height: 22.5 * mm, flexShrink: 0 }} dangerouslySetInnerHTML={{ __html: svg.replace('<svg ', '<svg style="width:100%;height:100%;display:block" ') }} />
        <div style={{ flex: 1, textAlign: 'center', minWidth: 0, position: 'relative' }}>
          <div style={{ fontFamily: TYPO.mono, fontWeight: 700, fontSize: 19, lineHeight: 1.05, color: '#2f363d', letterSpacing: 2 }}>{code.slice(0, 3)}</div>
          <div style={{ height: 1.5, width: 7 * mm, background: 'linear-gradient(90deg,#f7a447,#e8751a)', margin: '3.5px auto', borderRadius: 2 }} />
          <div style={{ fontFamily: TYPO.mono, fontWeight: 700, fontSize: 19, lineHeight: 1.05, color: '#2f363d', letterSpacing: 2 }}>{code.slice(3)}</div>
          <div style={{ fontSize: 6.5, color: '#8a8479', marginTop: 1.3 * mm, letterSpacing: '.14em', textTransform: 'uppercase' }}>kamir.sk</div>
        </div>
      </div>
      <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 6.2, color: '#8a8479', borderTop: '1px solid #e7e2db', paddingTop: .7 * mm }}>
        <span>Majetok KAMIR s.r.o.</span>
        <span style={{ fontFamily: TYPO.mono, fontWeight: 700, color: '#e8751a', fontSize: 6.8, letterSpacing: '.08em' }}>{code}</span>
      </div>
    </div>
  )
}
// Základ URL v QR kóde. Nálepka je TRVALÁ — musí viesť na verejnú adresu, aby sken
// fungoval aj z mobilných dát mimo firemnej siete (LAN IP by fungovala len v dielni).
const QR_PUBLIC_BASE = 'https://kamir.ksbx.sk'
const QR_BASE_KEY = 'kamir_qr_base'
function defaultQrBase() {
  try {
    const saved = localStorage.getItem(QR_BASE_KEY)
    if (saved) return saved
    const o = window.location.origin
    return /^https?:\/\/(localhost|127\.|10\.|192\.168\.|100\.|172\.(1[6-9]|2\d|3[01])\.)/.test(o) ? QR_PUBLIC_BASE : o
  } catch (_) { return QR_PUBLIC_BASE }
}
function QrPoolDialog({ onClose }) {
  const toast = useToast()
  const [count, setCount] = useState(28)
  const [busy, setBusy] = useState(false)
  const [list, setList] = useState([])
  const [base, setBase] = useState(defaultQrBase)
  const [fmt, setFmt] = useState('labels')   // 'labels' = podklad pre tlačiareň · 'sheet' = A4 na vlastné rezanie
  const [pdfBusy, setPdfBusy] = useState(false)
  const cleanBase = String(base || '').trim().replace(/\/+$/, '')
  const isLan = /^https?:\/\/(localhost|127\.|10\.|192\.168\.|100\.|172\.(1[6-9]|2\d|3[01])\.)/.test(cleanBase)
  const logoUrl = '/uploads/kamir_logo.png'   // relatívne — backend si to pri render-pdf prepíše na localhost
  const reload = useCallback(() => { fetchAuth('/api/loan-qr').then(r => r.ok ? r.json() : []).then(d => setList(Array.isArray(d) ? d : [])).catch(() => {}) }, [])
  useEffect(() => { reload() }, [reload])
  const batches = useMemo(() => {
    const m = {}
    list.forEach(r => {
      const b = r.batch || '—'
      if (!m[b]) m[b] = { batch: b, total: 0, free: 0, created_at: r.created_at || '' }
      m[b].total++
      if (!(r.item_id || '').trim()) m[b].free++
    })
    return Object.values(m).sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''))
  }, [list])
  const freeTotal = useMemo(() => list.filter(r => !(r.item_id || '').trim()).length, [list])
  const sampleCode = (list.find(r => !(r.item_id || '').trim()) || {}).code || 'K4M7X2'
  const saveBase = () => { try { localStorage.setItem(QR_BASE_KEY, cleanBase) } catch (_) {} }
  const download = (blob, fname) => {
    const u = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = u; a.download = fname; document.body.appendChild(a); a.click()
    setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(u) }, 1500)
  }
  const openSheet = (codes, batchLabel) => {
    saveBase()
    const html = qrPoolSheetHtml(codes, cleanBase, logoUrl, batchLabel, { mode: fmt })
    const w = window.open('', '_blank')
    if (w) { w.document.write(html); w.document.close() } else toast.error('Povoľ vyskakovacie okná — alebo použi „Stiahnuť PDF".')
  }
  // Skutočný PDF súbor pre tlačiareň — renderuje ho server (Chromium), nie tlač cez prehliadač.
  const downloadPdf = async (codes, batchName) => {
    if (!codes.length) { toast.error('Žiadne kódy.'); return }
    saveBase()
    setPdfBusy(true)
    try {
      const html = qrPoolSheetHtml(codes, cleanBase, logoUrl, batchName, { mode: fmt, forPdf: true })
      const fname = `KAMIR-QR-nalepky-${batchName || 'export'}-${codes.length}ks-${fmt === 'labels' ? '50x40mm' : 'A4'}.pdf`
      const r = await fetchAuth('/api/render-pdf', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ html, filename: fname }) })
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'PDF sa nevygenerovalo') }
      download(await r.blob(), fname)
      toast.success(`PDF stiahnuté (${codes.length} nálepiek) — pošli ho tlačiarni.`)
    } catch (e) { toast.error('Chyba: ' + e.message) } finally { setPdfBusy(false) }
  }
  // CSV zoznam kódov — pre tlačiareň, ktorá si nálepky sádže z vlastnej šablóny (variable data print).
  const downloadCsv = (codes, batchName) => {
    if (!codes.length) { toast.error('Žiadne kódy.'); return }
    saveBase()
    const rows = [['kod', 'url'], ...codes.map(c => [c, `${cleanBase}/v2/qr/${c}`])]
    const csv = '﻿' + rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(';')).join('\r\n')
    download(new Blob([csv], { type: 'text/csv;charset=utf-8' }), `KAMIR-QR-kody-${batchName || 'export'}-${codes.length}ks.csv`)
    toast.success('CSV stiahnuté.')
  }
  const codesOfBatch = (batch) => list.filter(r => (r.batch || '—') === batch).map(r => r.code).sort()
  const generate = async () => {
    const n = Math.max(1, Math.min(280, Number(count) || 0))
    saveBase()
    setBusy(true)
    try {
      const r = await fetchAuth('/api/loan-qr/generate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ count: n }) })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(d.error || 'Generovanie zlyhalo')
      const codes = d.codes || []
      toast.success(`Vygenerovaných ${codes.length} kódov (dávka ${d.batch}) — sťahujem PDF pre tlačiareň…`)
      reload()
      await downloadPdf(codes, d.batch)
    } catch (e) { toast.error('Chyba: ' + e.message) } finally { setBusy(false) }
  }
  return (
    <Modal open title="QR výroba — objednávka nálepiek u tlačiarne (50×40 mm)" onClose={onClose} width={680}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.text, lineHeight: 1.6, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.md }}>
          <b>Postup:</b> 1. vygeneruj kódy do zásoby → stiahne sa <b>PDF</b> (prípadne aj CSV) →
          2. pošli súbor tlačiarni na výrobu samolepiek →
          3. keď nálepky prídu, nalep ich na náradie a <b>naskenuj telefónom</b> — appka sama ponúkne priradenie k položke
          (alebo v katalógu tlačidlom „Priradiť QR kód").
          <div style={{ color: COLORS.muted, marginTop: 4 }}>Kódy si systém pamätá už od vygenerovania, takže priraďovať môžeš postupne, ako ti to vyhovuje.</div>
        </div>
        <div style={{ display: 'flex', gap: SPACE.lg, alignItems: 'center', background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.md }}>
          <LabelPreview code={sampleCode} logoUrl={logoUrl} base={cleanBase} />
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 800, fontSize: 15 }}>Ukážka nálepky</div>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 4, lineHeight: 1.5 }}>Skutočná veľkosť 50 × 40 mm · vodoznak KAMIR pod QR kódom · QR s vysokou korekciou chýb (ECC H), spoľahlivo čitateľný aj s vodoznakom. Kód je aj ľudsky čitateľný — dá sa nadiktovať do telefónu.</div>
            <div style={{ display: 'flex', gap: SPACE.sm, alignItems: 'flex-end', marginTop: 10 }}>
              <Field label="Počet nálepiek">
                <input type="number" min="1" max="280" value={count} onChange={e => setCount(e.target.value)} style={inputStyle} />
              </Field>
              <BtnAdd onClick={generate} disabled={busy || pdfBusy}>{busy ? 'Generujem…' : pdfBusy ? 'Robím PDF…' : 'Vygenerovať + stiahnuť PDF'}</BtnAdd>
            </div>
            <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 4 }}>Max. 280 naraz · v zásobe voľných kódov: <b>{freeTotal}</b></div>
          </div>
        </div>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 4 }}>Formát podkladu</div>
          <div style={{ display: 'flex', gap: 6 }}>
            {[{ k: 'labels', t: 'Pre tlačiareň — jednotlivé nálepky', s: 'každá nálepka samostatne, presne 50×40 mm, bez rezných čiar' },
              { k: 'sheet', t: 'Hárok A4 (4×7)', s: 'na vlastné rezanie — s čiarkovanými reznými čiarami' }].map(o => {
              const on = fmt === o.k
              return <button key={o.k} onClick={() => setFmt(o.k)} style={{ flex: 1, textAlign: 'left', padding: '8px 11px', borderRadius: RADIUS.md, cursor: 'pointer', fontFamily: 'inherit', background: on ? COLORS.brand : COLORS.bg, color: on ? '#fff' : COLORS.text, border: `1.5px solid ${on ? COLORS.brand : COLORS.line}` }}>
                <div style={{ fontWeight: 700, fontSize: TYPO.sizes.xs }}>{o.t}</div>
                <div style={{ fontSize: 10, opacity: .8, marginTop: 2 }}>{o.s}</div>
              </button>
            })}
          </div>
        </div>
        <div>
          <Field label="Adresa v QR kóde (nálepka je trvalá — musí fungovať aj mimo firemnej siete)">
            <input value={base} onChange={e => setBase(e.target.value)} style={inputStyle} placeholder={QR_PUBLIC_BASE} />
          </Field>
          <div style={{ fontSize: 11, marginTop: 4, lineHeight: 1.5, color: isLan ? COLORS.remove : COLORS.muted }}>
            {isLan
              ? <><b>Pozor:</b> toto je vnútrofiremná adresa — nálepka by fungovala len v dielni, na mobilných dátach nie. Pre výrobu použi <b>{QR_PUBLIC_BASE}</b>.</>
              : <>QR povedie na <b>{cleanBase}/v2/qr/KÓD</b>. Skontroluj to <b>pred</b> objednaním nálepiek — vytlačený kód sa už nedá zmeniť.</>}
          </div>
        </div>
        {batches.length > 0 && (
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 4 }}>Objednané dávky — podklad sa dá stiahnuť kedykoľvek znova</div>
            <div style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, overflow: 'hidden', maxHeight: 200, overflowY: 'auto' }}>
              {batches.map(b => (
                <div key={b.batch} style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, padding: '7px 12px', borderBottom: `1px solid ${COLORS.line}`, background: '#fff' }}>
                  <span style={{ fontFamily: TYPO.mono, fontWeight: 700, fontSize: TYPO.sizes.sm }}>{b.batch}</span>
                  <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{(b.created_at || '').slice(0, 16).replace('T', ' ')}</span>
                  <span style={{ flex: 1 }} />
                  <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{b.total} ks · nepriradených <b style={{ color: b.free ? COLORS.text : COLORS.muted }}>{b.free}</b></span>
                  <Btn variant="ghost" onClick={() => downloadPdf(codesOfBatch(b.batch), b.batch)} disabled={pdfBusy}>PDF</Btn>
                  <Btn variant="ghost" onClick={() => downloadCsv(codesOfBatch(b.batch), b.batch)}>CSV</Btn>
                  <Btn variant="ghost" onClick={() => openSheet(codesOfBatch(b.batch), b.batch)}>Náhľad</Btn>
                </div>
              ))}
            </div>
            <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 4, lineHeight: 1.5 }}><b>PDF</b> = hotový podklad na výrobu · <b>CSV</b> = zoznam kódov a odkazov, ak si tlačiareň sádže nálepky z vlastnej šablóny · <b>Náhľad</b> = otvorí v prehliadači.</div>
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose}>Zavrieť</BtnGhost>
        </div>
      </div>
    </Modal>
  )
}
// Priradenie / odobratie predtlačeného QR kódu v katalógu (58.11)
function AssignQrDialog({ item, onClose, onDone }) {
  const toast = useToast()
  const confirm = useConfirm()
  const [free, setFree] = useState([])
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)
  useEffect(() => { fetchAuth('/api/loan-qr?free=1').then(r => r.ok ? r.json() : []).then(d => setFree(Array.isArray(d) ? d : [])).catch(() => {}) }, [])
  const uid = (item.uid || '').trim()
  const assign = async () => {
    const c = String(code || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
    if (!c) { toast.error('Vyber kód z nálepky, ktorú si nalepil na náradie.'); return }
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/loan-qr/${encodeURIComponent(c)}/assign`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ item_id: item.id }) })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(d.error === 'NOT_FOUND' ? 'Taký kód v systéme neexistuje — vygeneruj ho cez „QR výroba".' : d.error === 'ALREADY_ASSIGNED' ? 'Kód už je priradený inej položke.' : d.error === 'ITEM_HAS_CODE' ? ('Položka už má kód ' + (d.uid || '') + ' — najprv ho odober.') : (d.error || 'Priradenie zlyhalo'))
      toast.success('QR kód ' + c + ' priradený.')
      onDone()
    } catch (e) { toast.error('Chyba: ' + e.message) } finally { setBusy(false) }
  }
  const unassign = async () => {
    const ok = await confirm({ title: 'Odobrať QR kód?', message: `Odobrať kód ${uid} z položky ${item.name || item.id}? Kód sa vráti medzi voľné — nálepku z náradia strhni, inak bude sken ukazovať „nepriradený kód".`, danger: true, confirmLabel: 'Odobrať' })
    if (!ok) return
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/loan-qr/${encodeURIComponent(uid)}/unassign`, { method: 'POST' })
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Odobratie zlyhalo') }
      toast.success('QR kód odobratý.')
      onDone()
    } catch (e) { toast.error('Chyba: ' + e.message) } finally { setBusy(false) }
  }
  return (
    <Modal open title={uid ? 'QR kód položky' : 'Priradiť QR kód'} onClose={onClose} width={480}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        {uid ? (
          <>
            <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.text }}>Položka <b>{item.name}</b> má priradený predtlačený QR kód:</div>
            <div style={{ fontFamily: TYPO.mono, fontWeight: 800, fontSize: 26, letterSpacing: 3, textAlign: 'center', padding: SPACE.md, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md }}>{uid}</div>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Sken nálepky otvorí kartu tejto položky. Kód je trvalý — meniť ho treba len pri zničenej nálepke.</div>
            <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
              <Btn variant="delete" onClick={unassign} disabled={busy}>Odobrať kód</Btn>
              <BtnGhost onClick={onClose}>Zavrieť</BtnGhost>
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, lineHeight: 1.5 }}>Vyber kód nálepky, ktorú si nalepil na toto náradie ({free.length} voľných). Tip: nálepku môžeš rovno <b>naskenovať telefónom</b> — priradenie ponúkne samo.</div>
            <Field label="Kód z nálepky">
              <SearchableSelect value={code} onChange={setCode}
                options={free.map(f => ({ value: f.code, label: f.code + (f.batch ? '  ·  hárok ' + f.batch : '') }))}
                placeholder="Hľadaj / vyber kód…" />
            </Field>
            <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
              <BtnGhost onClick={onClose}>Zrušiť</BtnGhost>
              <BtnAdd onClick={assign} disabled={busy || !code}>{busy ? 'Priraďujem…' : 'Priradiť kód'}</BtnAdd>
            </div>
          </>
        )}
      </div>
    </Modal>
  )
}

// ── Doklad o výpožičke (ústava 58.5) — tlačiteľný A4 + podpis + časová pečiatka ──
function dokladHtml(lr) {
  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  const ts = (lr.created_at || '').replace('T', ' ').slice(0, 19) || new Date().toISOString().replace('T', ' ').slice(0, 19)
  const intern = lr.loan_type === 'intern'
  const preb = intern ? (lr.employee_name || lr.employee_id || '—') : (lr.customer_name || lr.customer_id || '—')
  const rows = []
  rows.push(['Položka', (lr.item_name || '—') + (lr.item_code ? ' · ' + lr.item_code : '')])
  // Počet kusov (Mirko 30. 9. 2026: „na doklade o vypožičke mi nezobrazuje počet kusov"). Množstvo je
  // v loan_records.qty a API ho vracia; doklad ho dovtedy nevypisoval vôbec — kto ho podpísal, podpísal
  // výpožičku bez počtu a pri vracaní sa nedalo zistiť, koľko malo prísť späť. Pri množstvových položkach
  // sa vypíše vždy, pri kusových strojoch len keď je ich viac než jeden (tam je výrobné číslo).
  { const ks = Number(lr.qty) || 1; if (lr.item_tracking === 'ks' || ks > 1) rows.push(['Počet kusov', ks + ' ks']) }
  if (lr.item_description) rows.push(['Popis produktu', lr.item_description])
  if (lr.serial_number) rows.push(['Výrobné číslo', lr.serial_number])
  rows.push(['Typ výpožičky', intern ? 'Interná (firemná — zadarmo)' : 'Externá (zákazník)'])
  rows.push([intern ? 'Parťák (preberajúci)' : 'Zákazník (preberajúci)', preb])
  if (intern && (lr.project_id || lr.project_name)) rows.push(['Zákazka', (lr.project_id || '') + (lr.project_name ? ' · ' + lr.project_name : '')])
  rows.push(['Dátum od', lr.start_date || '—'])
  if (lr.end_date) rows.push(['Plánovaný návrat', lr.end_date])
  if (!intern) { rows.push(['Sadzba', (Number(lr.rate_used) || 0).toFixed(2) + ' ' + (lr.rate_unit || '')]); rows.push(['Záloha / depozit', (Number(lr.deposit) || 0).toFixed(2) + ' €']) }
  if (lr.not_delivered) rows.push(['Čo sa NEvydalo', lr.not_delivered])
  if (lr.notes) rows.push(['Poznámka', lr.notes])
  const trs = rows.map(([k, v]) => `<tr><td class="k">${esc(k)}</td><td class="v">${esc(v)}</td></tr>`).join('')
  return `<!DOCTYPE html><html lang="sk"><head><meta charset="utf-8"><title>Doklad o výpožičke ${esc(lr.id)}</title>
<style>*{box-sizing:border-box}body{font-family:-apple-system,system-ui,'Segoe UI',Arial,sans-serif;color:#1f2937;margin:0;background:#d9d6d1;padding:22px;font-size:13px}
.toolbar{max-width:800px;margin:0 auto 12px}.btn{background:#16a34a;color:#fff;border:none;padding:9px 16px;border-radius:8px;font-weight:700;cursor:pointer}
.page{max-width:800px;margin:0 auto;background:#fff;padding:28px 32px;box-shadow:0 1px 4px rgba(0,0,0,.12)}
.top{display:flex;align-items:flex-start;gap:16px;border-bottom:3px solid #ef9350;padding-bottom:12px}.top img{height:44px}
.ttl{flex:1;text-align:center}.ttl h1{margin:0;font-size:21px;letter-spacing:1px}.ttl .sub{color:#d97a3a;font-weight:700;margin-top:3px}
.docno{text-align:right;font-size:12px;color:#6b6359}
table{width:100%;border-collapse:collapse;margin-top:16px}td{border:1px solid #e7e2db;padding:7px 10px;vertical-align:top}
td.k{width:210px;color:#6b6359;font-weight:600;background:#faf7f2}td.v{font-weight:600}
.sign{display:grid;grid-template-columns:1fr 1fr;gap:40px;margin-top:50px}.sg{text-align:center}.sg .line{border-top:1px solid #555;margin-top:42px;padding-top:6px;font-size:12px;color:#6b6359}.sg .who{font-weight:700;color:#1f2937}
.foot{margin-top:18px;border-top:1px solid #e7e2db;padding-top:8px;font-size:10px;color:#6b6359;display:flex;justify-content:space-between}
@media print{body{background:#fff;padding:0}.toolbar{display:none}.page{box-shadow:none;max-width:100%;padding:14mm}@page{size:A4;margin:0}}</style></head><body>
<div class="toolbar"><button class="btn" onclick="window.print()">Tlačiť / Uložiť PDF</button></div>
<div class="page">
<div class="top"><img src="/uploads/kamir_logo.png" alt="KAMIR" onerror="this.style.display='none'"><div class="ttl"><h1>DOKLAD O VÝPOŽIČKE</h1><div class="sub">Požičovňa náradia a strojov · KAMIR s.r.o.</div></div><div class="docno">Č. <b>${esc(lr.id)}</b><br>Vystavené:<br>${esc(ts)}</div></div>
<table>${trs}</table>
${(lr.photo_before || lr.photo_after) ? `<div style="display:flex;gap:16px;margin-top:14px;flex-wrap:wrap">${lr.photo_before ? `<div><div style="font-weight:700;font-size:11px;color:#6b6359;margin-bottom:4px">Foto stavu PRI VÝDAJI</div><img src="${esc(/^https?:/.test(lr.photo_before) ? lr.photo_before : (location.origin + lr.photo_before))}" style="max-width:240px;max-height:170px;border:1px solid #e7e2db;border-radius:4px"></div>` : ''}${lr.photo_after ? `<div><div style="font-weight:700;font-size:11px;color:#6b6359;margin-bottom:4px">Foto stavu PRI VRÁTENÍ</div><img src="${esc(/^https?:/.test(lr.photo_after) ? lr.photo_after : (location.origin + lr.photo_after))}" style="max-width:240px;max-height:170px;border:1px solid #e7e2db;border-radius:4px"></div>` : ''}</div>` : ''}
<div class="sign"><div class="sg"><div class="line"><div class="who">Preberajúci — ${esc(preb)}</div>dátum a podpis</div></div><div class="sg"><div class="line"><div class="who">Za KAMIR s.r.o. (odovzdal)</div>dátum a podpis</div></div></div>
<div class="foot"><span>KAMIR s.r.o. · IČO 48029882 · Prešov · kamir.sk</span><span>Časová pečiatka: ${esc(ts)} · MATRIX</span></div>
</div></body></html>`
}
function printDoklad(lr) {
  const w = window.open('', '_blank')
  if (w) { w.document.write(dokladHtml(lr)); w.document.close() } else alert('Povoľ vyskakovacie okná pre tlač dokladu.')
}

function DetailPane({ record, onEdit, onReload, onAfterLoan, katalog = false, navigate }) {
  const [showLoan, setShowLoan] = useState(false)
  const [showReturn, setShowReturn] = useState(false)
  const [tab, setTab] = useState('detail')
  const [assignQr, setAssignQr] = useState(false)   // predtlačený QR kód (58.11)
  const toast = useToast()
  const openDoklad = async () => {
    try {
      const r = await fetchAuth(`/api/loan-records?item_id=${record.id}&active_only=1`)
      const rows = await r.json()
      const lr = (Array.isArray(rows) ? rows : [])[0]
      if (!lr) { toast.error('Žiadna aktívna výpožička na doklad.'); return }
      printDoklad(lr)
    } catch (_) { toast.error('Doklad sa nepodarilo otvoriť.') }
  }
  return (
    <div style={{
      background: COLORS.bg,
      border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.lg,
      height: '100%',
      display: 'flex', flexDirection: 'column',
      overflow: 'hidden',
    }}>
      {/* HLAVIČKA KARTY — tenký stavový pásik + čierny názov (ústava 61.6) */}
      <div style={{ height: 4, background: COLORS.brand }} />
      <div style={{
        display: 'flex', alignItems: 'center', gap: SPACE.md,
        padding: `${SPACE.md}px ${SPACE.lg}px`,
        borderBottom: `1px solid ${COLORS.line}`,
      }}>
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra,
          color: COLORS.text }}>
          {record.name || '(bez názvu)'}{(fmtCode(record.code) && !(record.name || '').includes(fmtCode(record.code))) ? <span style={{ color: COLORS.brand, fontWeight: 900, marginLeft: 8 }}>{fmtCode(record.code)}</span> : null}
        </h2>
        <StatusTag status={effStatus(record)} />
        <div style={{ flex: 1 }} />
        {katalog && <Btn variant={(record.uid || '').trim() ? 'ghost' : 'nav'} onClick={() => setAssignQr(true)}>{(record.uid || '').trim() ? 'QR kód ' + record.uid : 'Priradiť QR kód'}</Btn>}
        {katalog ? (
          <Btn variant="nav" onClick={onEdit}>Upraviť</Btn>
        ) : (
          <>
            <Btn variant="ghost" onClick={() => { if (navigate) navigate('/katalog/pozicovna') }}>Detail stroja</Btn>
            {effStatus(record) === 'dostupne' && <BtnAdd onClick={() => setShowLoan(true)}>Vypožičať</BtnAdd>}
            {(effStatus(record) === 'pozicane' || ksHasLoan(record)) && <Btn variant="nav" onClick={openDoklad}>Doklad</Btn>}
            {(effStatus(record) === 'pozicane' || ksHasLoan(record)) && <Btn variant="remove" onClick={() => setShowReturn(true)}>Vrátiť</Btn>}
          </>
        )}
      </div>

      <div style={{ padding: SPACE.md, overflow: 'auto', flex: 1, background: COLORS.bg,
        border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg }}>
        <Tabs
          value={tab}
          onChange={setTab}
          tabs={katalog ? [
            { key: 'detail',  label: 'Detail' },
            { key: 'fotky',   label: 'Fotky' },
            ...(record.tracking === 'kus' ? [{ key: 'zostava', label: 'Zostava' }, { key: 'servis', label: 'Servis' }] : []),
            { key: 'history', label: 'História' },
          ] : [
            { key: 'detail',  label: 'Detail' },
            { key: 'history', label: 'História' },
          ]}
        />
        {tab === 'zostava' && <ZostavaTab record={record} onReload={onReload} />}
        {tab === 'servis' && <ServisTab itemId={record.id} category={record.category} />}
        {tab === 'fotky' && (
          <div style={{ paddingTop: SPACE.md }}>
            {(record.photo_count || 0) === 0 && (
              <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', background: 'rgba(239,68,68,0.07)', border: `1px solid ${COLORS.remove}`, borderRadius: RADIUS.md, padding: '10px 14px', marginBottom: SPACE.md }}>
                <span style={{ fontSize: 20, color: COLORS.remove, lineHeight: 1 }}>!</span>
                <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.text, lineHeight: 1.5 }}>
                  <b style={{ color: COLORS.remove }}>Chýba reálne foto stroja.</b> Nahraj <b>viac fotiek z každej strany</b> (predok · bok · štítok so sériou · stav). Bez foto = sporné pri vrátení/poškodení a v zozname svieti červené „!". Univerzálna ikona je len orientačná.
                </div>
              </div>
            )}
            <AttachmentsPanel entityType="loan_item" entityId={record.id} showPhase={false}
              mainUrl={record.photo_url || ''}
              onSetMain={async (url) => {
                try {
                  const r = await fetchAuth(`/api/loan-items/${record.id}/set-photo`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ url }) })
                  if (!r.ok) throw new Error()
                  toast.success('Miniatúra nastavená'); if (onReload) onReload()
                } catch (_) { toast.error('Nepodarilo sa nastaviť miniatúru') }
              }} />
          </div>
        )}
        {tab === 'detail' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md, paddingTop: SPACE.sm }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="Názov" value={record.name} />
              <KrosF label="Kód" value={record.code} mono />
              <KrosF label="Kategória" value={record.category} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="Režim" value={record.tracking === 'kus' ? 'Na KUS' : 'Na množstvo (Ks)'} />
              <KrosF label="Sadzba" value={(Number(record.rate) || 0).toFixed(2) + ' ' + (record.rate_unit || '')} mono />
              <KrosF label="Stav položky" value={STATUS_LABEL[effStatus(record)] || effStatus(record)} />
            </div>
            {(record.description || record.nfc_tag || (record.uid || '').trim()) && (
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: SPACE.sm }}>
                <KrosF label="Popis produktu" value={record.description} />
                <KrosF label="QR kód (nálepka)" value={record.uid} mono />
                <KrosF label="NFC tag" value={record.nfc_tag} mono />
              </div>
            )}
            {record.tracking === 'kus' && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
                <KrosF label="Výrobné č." value={record.serial_number} mono />
                <KrosF label="Model" value={record.model} />
                <KrosF label="Farba" value={record.color} />
              </div>
            )}
            {record.tracking === 'ks' && <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}><KrosF label="Počet ks (sklad)" value={String(record.qty || 0)} mono /><KrosF label="Voľné" value={String(record.available_ks != null ? record.available_ks : (record.qty || 0))} mono /><KrosF label="Požičané" value={String(record.loaned_ks || 0)} mono /></div>}
            {record.notes && <KrosF label="Poznámka" value={record.notes} />}
          </div>
        )}
        {tab === 'history' && (
          // audit kto/čo/kedy (ústava 12.0 bod 1).
          <HistoryPanel module={CFG.resource} entityId={record.id} />
        )}
      </div>
      {showLoan && (
        <LoanDialog
          item={record}
          onClose={() => setShowLoan(false)}
          onDone={() => { setShowLoan(false); if (onAfterLoan) onAfterLoan(); else if (onReload) onReload() }}
        />
      )}
      {showReturn && (
        <ReturnDialog
          item={record}
          onClose={() => setShowReturn(false)}
          onDone={() => { setShowReturn(false); if (onAfterLoan) onAfterLoan(); else if (onReload) onReload() }}
        />
      )}
      {assignQr && <AssignQrDialog item={record} onClose={() => setAssignQr(false)} onDone={() => { setAssignQr(false); if (onReload) onReload() }} />}
    </div>
  )
}


// KrosF — KROS boxované pole (label uppercase + hodnota v rámčeku) — ústava 92
function KrosF({ label, value, mono }) {
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 2 }}>{label}</div>
      <div style={{ padding: '4px 9px', background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, fontWeight: 600, fontFamily: mono ? TYPO.mono : 'inherit', wordBreak: 'break-word', minHeight: 22, color: COLORS.text }}>{(value !== null && value !== undefined && value !== '') ? value : '—'}</div>
    </div>
  )
}

// ── ServisTab — Servisná kniha položky NA KUS (ústava 58.6) ─────────────────
// Preddefinované typy servisných úkonov + odporúčaná náplň/diel (PFT G4 + bežná prax, Mirko 2026-06-13)
const SERVIS_TYPY = [
  { v: 'olej',      l: 'Výmena oleja (prevodovka)', n: 'prevodový olej' },
  { v: 'rotor',     l: 'Rotor + Stator',            n: 'sada rotor + stator' },
  { v: 'hriadel',   l: 'Miešacia hriadeľ',          n: 'miešacia hriadeľ' },
  { v: 'filtre',    l: 'Filtre (voda + vzduch)',    n: 'vodný / vzduchový filter' },
  { v: 'mazanie',   l: 'Mazanie / tuk',             n: 'mazací tuk' },
  { v: 'inspekcia', l: 'Ročná inšpekcia',           n: '' },
  { v: 'oprava',    l: 'Oprava / porucha',          n: '' },
  { v: 'ine',       l: 'Iné',                       n: '' },
]
const SERVIS_TYP_L = Object.fromEntries(SERVIS_TYPY.map(t => [t.v, t.l]))

// Odporúčania výrobcu — zdroj: oficiálny manuál Knauf PFT „Mixing pump G 4 X" (2016-11-25), sekcia 50 Maintenance
function servisOdporucania(category) {
  const c = (category || '').toLowerCase()
  if (/omiet|g4|g 4|pft/.test(c)) return {
    typ: 'PFT G4 X — odporúčania výrobcu (Knauf PFT)',
    riadky: [
      ['Po KAŽDOM použití', 'Dôkladné vyčistenie stroja — výrobca uvádza ako NAJDÔLEŽITEJŠIU údržbu.'],
      ['Mesačne', 'Vyčistiť/vymeniť: filter kompresora · plastové sitko v lapači · sitko v redukčnom ventile (náhradný diel čl. 20156000).'],
      ['Mazanie', 'Ručne premazať mazacie body, starý tuk odstrániť.'],
      ['Prevodovka', '2-stupňová, BEZÚDRŽBOVÁ — PFT NEPREDPISUJE výmenu oleja (mazanie na životnosť).'],
      ['Rotor + stator', 'Opotrebiteľný diel — VYMENIŤ keď tlak klesne pod 25 bar (životnosť cca 10–20 paliet).'],
      ['Miešacia hriadeľ', 'Životnosť cca 80–120 paliet.'],
      ['Ročne', 'Periodická inšpekcia odborníkom.'],
      ['Tlakové spínače', 'Voda ZAP 2,2 / VYP 1,9 bar · Vzduch ZAP 0,9 / VYP 1,2 bar · Kompresor ZAP 2,5 / VYP 3,1 bar.'],
    ],
  }
  if (/silomat|hru[sš]/.test(c)) return {
    typ: 'Silomat / Hruška — častá údržba',
    riadky: [
      ['Po každom použití', 'Dôkladne vyčistiť — zvyšky zmesi spôsobujú upchatie a koróziu.'],
      ['Pravidelne', 'Premazať pohyblivé časti a ložiská.'],
      ['Kontrola', 'Tesnenia, hadice a spoje na opotrebenie/netesnosť.'],
      ['Pozor', 'Vyžadujú častejšiu údržbu než omietačka — kontroluj pred každým nasadením.'],
    ],
  }
  return null
}
// Návody + technické výkresy per typ — offline PDF (uložený v Matrixe) + online exploded diagramy (Mirko 2026-06-13)
function servisNavody(category) {
  const c = (category || '').toLowerCase()
  const offline = [{ label: 'Prevádzkový manuál + technické výkresy PFT G4 X (PDF)', url: '/uploads/manuals/pft-g4-manual.pdf' }]
  const g4online = [
    { label: 'Náhradné diely + exploded diagramy (PFT G4)', url: 'https://english.pftg4.com/pft-g4-spare-parts/' },
    { label: 'Knauf PFT — G4 (oficiálna stránka)', url: 'https://www.pft.net/en/mixing-conveying/mixing-pumps/g-series/g4.html' },
  ]
  if (/motor/.test(c)) return { offline, online: [{ label: 'Hlavný motor + prevodovka G4 (diely)', url: 'https://english.pftg4.com/main-motor-gearbox-g4/' }, ...g4online] }
  if (/omiet|g4|g 4|pft|r[áa]m|kompres|silomat|hru[sš]|sond|kapot|hadic/.test(c)) return { offline, online: g4online }
  return null
}

function ServisTab({ itemId, category }) {
  const { user } = useAuth()
  const canEdit = ['admin', 'owner', 'owner_view', 'office_manager', 'service'].includes(user?.role)
  const toast = useToast()
  const [rows, setRows] = useState(null)
  const [adding, setAdding] = useState(false)
  const blank = { service_date: todayLocal(), op_type: 'olej', consumable: '', quantity: '', usage_note: '', description: '', cost: '', next_service_date: '' }
  const [form, setForm] = useState(blank)
  const load = () => fetchAuth(`/api/loan-items/${itemId}/service`).then(r => r.ok ? r.json() : []).then(d => setRows(Array.isArray(d) ? d : [])).catch(() => setRows([]))
  useEffect(() => { load() }, [itemId])
  // Pri zmene typu úkonu predvyplň náplň/diel odporúčaným, ak je prázdne
  const setType = (v) => setForm(f => {
    const t = SERVIS_TYPY.find(x => x.v === v)
    return { ...f, op_type: v, consumable: f.consumable.trim() ? f.consumable : (t ? t.n : '') }
  })
  const save = async () => {
    if (!form.op_type) { toast.error('Vyber typ úkonu'); return }
    try {
      const r = await fetchAuth('/api/loan-service', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ item_id: itemId, ...form, cost: Number(form.cost) || 0 }) })
      if (!r.ok) throw new Error('save')
      toast.success('Servisný záznam pridaný'); setAdding(false); setForm(blank); load()
    } catch (_) { toast.error('Chyba pri ukladaní') }
  }
  const del = async (id) => { try { await fetchAuth(`/api/loan-service/${id}`, { method: 'DELETE' }); load() } catch (_) {} }
  if (rows === null) return <div style={{ paddingTop: SPACE.md, color: COLORS.muted }}>Načítavam servisnú knihu…</div>
  const upcoming = rows.map(r => r.next_service_date).filter(Boolean).sort()[0]
  const inputStyle = { width: '100%', padding: '6px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, boxSizing: 'border-box' }
  const lblStyle = { fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 3 }
  const odpor = servisOdporucania(category)
  const nav = servisNavody(category)
  return (
    <div style={{ paddingTop: SPACE.md, display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.bold }}>Servisná kniha — na kus</span>
        <HelpHint section="58" text="ČO: každý servisný úkon na tomto stroji do preddefinovaných buniek (Typ · Náplň/diel · Množstvo · Prevádzka · Náklad). PREČO: PFT meria opotrebenie v PALETÁCH — zapíš nájazd do poľa Prevádzka, nech pri ďalšom servise vidíš kedy a pri akom nájazde bol naposledy. KAM: žlté pole nižšie = oficiálne intervaly výrobcu." />
      </div>
      {odpor && (
        <div style={{ border: `1px solid ${COLORS.warn}`, borderRadius: RADIUS.md, background: 'rgba(245,158,11,0.07)', padding: SPACE.md }}>
          <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.bold, color: '#92400e', marginBottom: 6 }}>{odpor.typ}</div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
            <tbody>{odpor.riadky.map(([k, v], i) => (
              <tr key={i} style={{ borderTop: i ? `1px solid rgba(245,158,11,0.25)` : 'none' }}>
                <td style={{ padding: '4px 8px 4px 0', fontWeight: TYPO.weights.bold, whiteSpace: 'nowrap', verticalAlign: 'top', color: COLORS.text }}>{k}</td>
                <td style={{ padding: '4px 0', color: COLORS.text, lineHeight: 1.45 }}>{v}</td>
              </tr>
            ))}</tbody>
          </table>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 6 }}>Zdroj: oficiálny manuál Knauf PFT „Mixing pump G 4 X" (2016-11-25), sekcia 50 Maintenance.</div>
        </div>
      )}
      {nav && (
        <div style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, background: COLORS.bgSoft, padding: SPACE.md }}>
          <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.bold, marginBottom: 6 }}>Návody a technické výkresy</div>
          {nav.offline.map((d, i) => (
            <a key={'o' + i} href={d.url} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', fontSize: TYPO.sizes.sm, color: COLORS.nav, textDecoration: 'none' }}>
              <span style={{ fontSize: 10, fontWeight: 800, color: '#fff', background: COLORS.add, borderRadius: RADIUS.full, padding: '1px 7px', whiteSpace: 'nowrap' }}>OFFLINE</span>{d.label}
            </a>
          ))}
          {nav.online.map((d, i) => (
            <a key={'n' + i} href={d.url} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', fontSize: TYPO.sizes.sm, color: COLORS.nav, textDecoration: 'none' }}>
              <span style={{ fontSize: 10, fontWeight: 800, color: COLORS.muted, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.full, padding: '1px 6px', whiteSpace: 'nowrap' }}>online</span>{d.label}
            </a>
          ))}
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 6 }}>OFFLINE súbory sú uložené priamo v Matrixe — technický výkres funguje aj bez internetu.</div>
        </div>
      )}
      {upcoming && <div style={{ padding: SPACE.sm, background: 'rgba(245,158,11,0.1)', border: `1px solid ${COLORS.warn}`, borderRadius: RADIUS.md, fontSize: TYPO.sizes.sm, color: '#92400e' }}>Ďalší servis naplánovaný: <b>{upcoming}</b></div>}
      {canEdit && (adding ? (
        <div style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.md, background: COLORS.bgSoft, display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.sm }}>
            <div><div style={lblStyle}>Typ úkonu *</div><select value={form.op_type} onChange={e => setType(e.target.value)} style={inputStyle}>{SERVIS_TYPY.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}</select></div>
            <div><div style={lblStyle}>Dátum úkonu</div><input type="date" value={form.service_date} onChange={e => setForm(f => ({ ...f, service_date: e.target.value }))} style={inputStyle} /></div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.sm }}>
            <div><div style={lblStyle}>Náplň / diel — aký?</div><input list="servis-naplne" value={form.consumable} onChange={e => setForm(f => ({ ...f, consumable: e.target.value }))} placeholder="napr. prevodový olej, rotor+stator" style={inputStyle} /></div>
            <div><div style={lblStyle}>Množstvo — koľko?</div><input value={form.quantity} onChange={e => setForm(f => ({ ...f, quantity: e.target.value }))} placeholder="napr. 2 L · 1 ks · 0,5 kg" style={inputStyle} /></div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px', gap: SPACE.sm }}>
            <div><div style={lblStyle}>Prevádzka pri servise — palety / motohodiny</div><input value={form.usage_note} onChange={e => setForm(f => ({ ...f, usage_note: e.target.value }))} placeholder="napr. 14 paliet · 120 mth" style={inputStyle} /></div>
            <div><div style={lblStyle}>Náklad €</div><input type="number" step="0.01" value={form.cost} onChange={e => setForm(f => ({ ...f, cost: e.target.value }))} style={inputStyle} /></div>
          </div>
          <div><div style={lblStyle}>Dôvod / poznámka — prečo · načo</div><input value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="napr. tlak klesol pod 25 bar, plánovaná výmena…" style={inputStyle} /></div>
          <div style={{ maxWidth: 260 }}><div style={lblStyle}>Ďalší servis (dátum)</div><input type="date" value={form.next_service_date} onChange={e => setForm(f => ({ ...f, next_service_date: e.target.value }))} style={inputStyle} /></div>
          <datalist id="servis-naplne"><option value="prevodový olej" /><option value="hydraulický olej" /><option value="sada rotor + stator" /><option value="miešacia hriadeľ" /><option value="vodný filter" /><option value="vzduchový filter" /><option value="mazací tuk" /></datalist>
          <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}><BtnGhost onClick={() => { setAdding(false); setForm(blank) }}>Zrušiť</BtnGhost><BtnAdd onClick={save}>Uložiť záznam</BtnAdd></div>
        </div>
      ) : <div><BtnAdd onClick={() => setAdding(true)}>+ Servisný záznam</BtnAdd></div>)}
      {rows.length === 0 ? <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Žiadne servisné záznamy.</div> : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
          <thead><tr style={{ borderBottom: `1px solid ${COLORS.line}`, color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase' }}>
            <th style={{ textAlign: 'left', padding: '4px 6px' }}>Dátum</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Úkon</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Náplň · množ.</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Prevádzka</th><th style={{ textAlign: 'right', padding: '4px 6px' }}>Náklad</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Ďalší</th><th></th>
          </tr></thead>
          <tbody>{rows.map(r => (
            <tr key={r.id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '5px 6px', fontFamily: TYPO.mono, whiteSpace: 'nowrap', verticalAlign: 'top' }}>{r.service_date}</td>
              <td style={{ padding: '5px 6px', verticalAlign: 'top' }}>
                <div>{SERVIS_TYP_L[r.op_type] || r.description || '—'}{r.kind === 'vsost' && <span style={{ marginLeft: 6, fontSize: 10, color: COLORS.nav }}>VSOST</span>}</div>
                {r.op_type && r.description && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{r.description}</div>}
              </td>
              <td style={{ padding: '5px 6px', verticalAlign: 'top' }}>{r.consumable || '—'}{r.quantity ? <span style={{ color: COLORS.muted }}> · {r.quantity}</span> : ''}</td>
              <td style={{ padding: '5px 6px', color: COLORS.muted, verticalAlign: 'top' }}>{r.usage_note || '—'}</td>
              <td style={{ padding: '5px 6px', textAlign: 'right', fontFamily: TYPO.mono, verticalAlign: 'top' }}>{Number(r.cost) > 0 ? Number(r.cost).toFixed(2) + ' €' : '—'}</td>
              <td style={{ padding: '5px 6px', fontFamily: TYPO.mono, color: COLORS.muted, verticalAlign: 'top' }}>{r.next_service_date || '—'}</td>
              <td style={{ padding: '5px 6px', textAlign: 'right', verticalAlign: 'top' }}>{canEdit && <span onClick={() => del(r.id)} title="zmazať" style={{ cursor: 'pointer', color: COLORS.remove }}>✕</span>}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </div>
  )
}

// ══════════════════════════════════════════════════════════════════
// RECORD MODAL — edit / new cez useRecordEditor (S1)
// Lock + dirty + Form→Confirm + DIFF — všetko zabudované v hooku.
// ══════════════════════════════════════════════════════════════════
// ── ZostavaTab — komponenty stroja (ústava 58.2) ────────────────────────────
// Exploded view — reálne foto dielov sa animovane rozložia a zložia (Mirko 2026-06-13)
function OmietackaExploded() {
  const [open, setOpen] = useState(false)
  const timer = useRef(null)
  useEffect(() => { timer.current = setInterval(() => setOpen(o => !o), 2300); return () => { if (timer.current) clearInterval(timer.current) } }, [])
  const stop = () => { if (timer.current) { clearInterval(timer.current); timer.current = null } }
  const base = { position: 'absolute', objectFit: 'contain', transition: 'transform .65s cubic-bezier(.45,.05,.3,1)' }
  const hideErr = (e) => { e.currentTarget.style.opacity = 0.12 }
  const cap = { position: 'absolute', fontSize: 11, fontWeight: 800, transition: 'opacity .5s', whiteSpace: 'nowrap' }
  return (
    <div style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, background: COLORS.bgSoft, padding: SPACE.sm, marginBottom: SPACE.sm }}>
      <div style={{ position: 'relative', height: 210, overflow: 'hidden' }}>
        <img src={PART_PHOTO_BASE + 'ram.png'} alt="rám" onError={hideErr}
          style={{ ...base, left: 'calc(50% - 90px)', top: 68, width: 180, height: 120 }} />
        <img src={PART_PHOTO_BASE + 'motor.png'} alt="motor" onError={hideErr}
          style={{ ...base, left: 'calc(50% - 96px)', top: 34, width: 96, height: 96, zIndex: 2, transform: open ? 'translate(-112px,-24px)' : 'none' }} />
        <img src={PART_PHOTO_BASE + 'kompresor.png'} alt="kompresor" onError={hideErr}
          style={{ ...base, left: 'calc(50% + 2px)', top: 34, width: 96, height: 96, zIndex: 2, transform: open ? 'translate(112px,-24px)' : 'none' }} />
        <span style={{ ...cap, left: 'calc(50% - 150px)', top: 8, color: COLORS.total, opacity: open ? 1 : 0 }}>Motor</span>
        <span style={{ ...cap, left: 'calc(50% + 96px)', top: 8, color: COLORS.total, opacity: open ? 1 : 0 }}>Kompresor</span>
        <span style={{ ...cap, left: 'calc(50% - 22px)', top: 188, color: COLORS.brand, opacity: 1 }}>Rám</span>
      </div>
      <div style={{ textAlign: 'center', marginTop: 4 }}>
        <BtnGhost size="sm" onClick={() => { stop(); setOpen(o => !o) }}>{open ? 'Zložiť stroj' : 'Rozložiť na diely'}</BtnGhost>
      </div>
    </div>
  )
}

// ── Generický animovaný rozklad zostavy (kapota+sonda, kompresor+hruška, silomat+hruška) — Mirko 2026-06-26 ──
function explodedConfig(category) {
  const c = (category || '').toLowerCase()
  if (/kapot/.test(c))   return { centerImg: 'kapota_bez.png', centerLabel: 'Kapota',   parts: [{ img: 'sonda.png',  label: 'Sonda',  left: 'calc(50% - 48px)', tx: 155, ty: 46, capLeft: 'calc(50% + 118px)' }] }
  if (/kompres/.test(c)) return { centerImg: 'kompresor.png', centerLabel: 'Kompresor', parts: [{ img: 'hruska.png', label: 'Hruška', left: 'calc(50% - 48px)', tx: 155, ty: 46, capLeft: 'calc(50% + 118px)' }] }
  if (/silomat/.test(c)) return { centerImg: 'silomat.png',  centerLabel: 'Silomat',  parts: [{ img: 'hruska.png', label: 'Hruška', left: 'calc(50% - 48px)', tx: 155, ty: 46, capLeft: 'calc(50% + 118px)' }] }
  return null
}
function PartExploded({ centerImg, centerLabel, parts }) {
  const [open, setOpen] = useState(false)
  const timer = useRef(null)
  useEffect(() => { timer.current = setInterval(() => setOpen(o => !o), 2300); return () => { if (timer.current) clearInterval(timer.current) } }, [])
  const stop = () => { if (timer.current) { clearInterval(timer.current); timer.current = null } }
  const base = { position: 'absolute', objectFit: 'contain', transition: 'transform .65s cubic-bezier(.45,.05,.3,1)' }
  const hideErr = (e) => { e.currentTarget.style.opacity = 0.12 }
  const cap = { position: 'absolute', fontSize: 11, fontWeight: 800, transition: 'opacity .5s', whiteSpace: 'nowrap' }
  return (
    <div style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, background: COLORS.bgSoft, padding: SPACE.sm, marginBottom: SPACE.sm }}>
      <div style={{ position: 'relative', height: 210, overflow: 'hidden' }}>
        <img src={PART_PHOTO_BASE + centerImg} alt={centerLabel} onError={hideErr}
          style={{ ...base, left: 'calc(50% - 90px)', top: 68, width: 180, height: 120 }} />
        {parts.map((p, i) => (
          <img key={i} src={PART_PHOTO_BASE + p.img} alt={p.label} onError={hideErr}
            style={{ ...base, left: p.left, top: 34, width: 96, height: 96, zIndex: 2, transform: open ? `translate(${p.tx}px,${p.ty}px)` : 'none' }} />
        ))}
        {parts.map((p, i) => (
          <span key={'c' + i} style={{ ...cap, left: p.capLeft, top: 8, color: COLORS.total, opacity: open ? 1 : 0 }}>{p.label}</span>
        ))}
        <span style={{ ...cap, left: 'calc(50% - 22px)', top: 188, color: COLORS.brand, opacity: 1 }}>{centerLabel}</span>
      </div>
      <div style={{ textAlign: 'center', marginTop: 4 }}>
        <BtnGhost size="sm" onClick={() => { stop(); setOpen(o => !o) }}>{open ? 'Zložiť' : 'Rozložiť na diely'}</BtnGhost>
      </div>
    </div>
  )
}
// ── Zostava omietačky — KONKRÉTNE DIELY (58.2.1, oprava 58.2.2 — Mirko 2026-06-13) ──
// Rám = identita stroja. Motor/kompresor = samostatné kusy, osadené cez parent_id. Diel sa dá vybrať (servis/voľný) → prázdny slot.
function OmietackaSwap({ record, onReload }) {
  const { meno } = usePersony()
  const { user } = useAuth()
  const canEdit = ['admin', 'owner', 'owner_view', 'office_manager', 'service'].includes(user?.role)
  const [comps, setComps] = useState([])
  const [moves, setMoves] = useState([])
  const [dlg, setDlg] = useState(null)
  const load = () => {
    fetchAuth(`/api/loan-items/${record.id}/components`).then(r => r.ok ? r.json() : []).then(d => setComps(Array.isArray(d) ? d : [])).catch(() => {})
    fetchAuth(`/api/loan-items/${record.id}/component-moves`).then(r => r.ok ? r.json() : []).then(d => setMoves(Array.isArray(d) ? d : [])).catch(() => {})
  }
  useEffect(() => { load() }, [record.id])
  const reload = () => { load(); if (onReload) onReload() }
  // part_slot pocita backend (_partKindOf) — jedno miesto pravdy pre obe strany.
  const slotOf = (c) => c.part_slot !== undefined ? c.part_slot
    : (/motor/i.test(c.category || '') ? 'motor' : (/kompres/i.test(c.category || '') && /mal/i.test(c.category || '') ? 'compressor' : ''))
  const motorPart = comps.find(c => slotOf(c) === 'motor')
  const compPart = comps.find(c => slotOf(c) === 'compressor')
  const SLOTS = [
    { kind: 'frame', label: 'Rám omietačky', fixed: true, serial: record.frame_serial },
    { kind: 'motor', label: 'Hlavný motor s prevodovkou', part: motorPart },
    { kind: 'compressor', label: 'Kompresor', part: compPart },
  ]
  const ACT = { osadenie: 'osadený', vybratie: 'vybraný (voľný)', na_servis: 'daný na servis', presun: 'presunutý' }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm, paddingTop: SPACE.sm }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.nav, background: TINT.info || '#eef4ff', border: `1px solid ${COLORS.info || COLORS.brand}`, borderRadius: RADIUS.md, padding: SPACE.sm, lineHeight: 1.5 }}>
        Stroj = <b>RÁM</b> (identita, vždy zostáva) + osadený <b>MOTOR</b> a <b>KOMPRESOR</b>. Každý diel je samostatný kus (vlastné výr. číslo, servis, QR). Diel môžeš <b>Vybrať</b> (na servis / voľný — stroj zostane bez neho) alebo <b>Osadiť</b> voľný diel.
      </div>
      <OmietackaExploded />
      {SLOTS.map(s => {
        const conn = s.part ? (s.part.motor_connector || s.part.compressor_connector) : ''
        return (
          <div key={s.kind} style={{ display: 'flex', alignItems: 'center', gap: 10, border: `1px solid ${(s.fixed || s.part) ? COLORS.line : COLORS.warn}`, borderRadius: RADIUS.md, padding: '8px 11px', background: (s.fixed || s.part) ? COLORS.bgSoft : 'rgba(245,158,11,0.06)' }}>
            <PartPhotoIcon kind={s.kind} color={s.fixed ? COLORS.brand : COLORS.total} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700 }}>{s.label}{s.part && s.part.status === 'v_servise' ? <span style={{ marginLeft: 6, fontSize: 10, fontWeight: 800, color: '#fff', background: COLORS.warn, borderRadius: RADIUS.full, padding: '1px 7px' }}>V SERVISE</span> : null}</div>
              {s.fixed ? (
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono }}>č. {s.serial || '—'}</div>
              ) : s.part ? (
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono }}>č. {s.part.serial_number || '—'}{s.part.color ? ' · ' + s.part.color : ''}{conn ? <span style={{ color: COLORS.nav, fontWeight: 700 }}> · koncovka {conn}</span> : ''}</div>
              ) : (
                <div style={{ fontSize: TYPO.sizes.xs, color: '#92400e', fontWeight: 700 }}>Prázdny slot — stroj je bez tohto dielu</div>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
              {s.fixed ? (
                <>
                  <span style={{ fontSize: 10, fontWeight: 800, color: '#fff', background: COLORS.brand, borderRadius: RADIUS.full, padding: '2px 9px', whiteSpace: 'nowrap' }}>VŽDY ZOSTÁVA</span>
                </>
              ) : s.part ? (
                <>
                  {canEdit && <BtnGhost size="sm" onClick={() => setDlg({ mode: 'vybrat', kind: s.kind, part: s.part, label: s.label })}>Vybrať</BtnGhost>}
                  {canEdit && <BtnGhost size="sm" onClick={() => setDlg({ mode: 'presunut', kind: s.kind, part: s.part, label: s.label })}>Presunúť</BtnGhost>}
                </>
              ) : (
                canEdit && <BtnAdd onClick={() => setDlg({ mode: 'osadit', kind: s.kind, label: s.label })}>Osadiť</BtnAdd>
              )}
            </div>
          </div>
        )
      })}
      {moves.length > 0 && (
        <div>
          <div style={{ fontSize: TYPO.sizes.xs, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', marginTop: 6, marginBottom: 4 }}>História dielov ({moves.length})</div>
          {moves.map(mv => (
            <div key={mv.id} style={{ fontSize: TYPO.sizes.xs, color: COLORS.text, padding: '4px 0', borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <span style={{ fontFamily: TYPO.mono, color: COLORS.muted }}>{(mv.created_at || '').slice(0, 10)}</span> · <b>{mv.component_name}</b> · {ACT[mv.action] || mv.action}{mv.to_name ? ' → ' + mv.to_name : (mv.from_name ? ' (z ' + mv.from_name + ')' : '')}{mv.reason ? ' · ' + mv.reason : ''}{mv.created_by ? ' · ' + meno(mv.created_by) : ''}
            </div>
          ))}
        </div>
      )}
      {dlg && <PartSlotDialog machine={record} dlg={dlg} onClose={() => setDlg(null)} onDone={() => { setDlg(null); reload() }} />}
    </div>
  )
}
// Dialóg osadiť / vybrať / presunúť konkrétny diel (58.2.1)
function PartSlotDialog({ machine, dlg, onClose, onDone }) {
  const { mode, kind, part, label } = dlg
  const toast = useToast()
  const [busy, setBusy] = useState(false)
  const [reason, setReason] = useState('')
  const [free, setFree] = useState([])
  const [pick, setPick] = useState('')
  const [removeStatus, setRemoveStatus] = useState('v_servise')
  const [machines, setMachines] = useState([])
  const [target, setTarget] = useState('')
  useEffect(() => {
    if (mode === 'osadit') fetchAuth(`/api/loan-parts/free?kind=${kind}`).then(r => r.ok ? r.json() : []).then(d => setFree(Array.isArray(d) ? d : [])).catch(() => {})
    if (mode === 'presunut') fetchAuth('/api/loan-items').then(r => r.ok ? r.json() : []).then(d => setMachines((Array.isArray(d) ? d : []).filter(x => isOmietacka(x.category) && x.id !== machine.id && x.active !== 0))).catch(() => {})
  }, [mode, kind])
  const lbl = { fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4, fontWeight: 700 }
  const inp = { width: '100%', padding: '8px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, boxSizing: 'border-box' }
  const submit = async () => {
    let partId, body
    if (mode === 'osadit') { if (!pick) { toast.error('Vyber voľný diel'); return } partId = pick; body = { parent_id: machine.id, reason } }
    else if (mode === 'vybrat') { partId = part.id; body = { parent_id: '', status: removeStatus, reason } }
    else { if (!target) { toast.error('Vyber cieľový stroj'); return } partId = part.id; body = { parent_id: target, reason } }
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/loan-parts/${partId}/assign`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      if (r.status === 409) { const d = await r.json().catch(() => ({})); toast.error('Cieľový stroj už má diel: ' + (d.occupiedName || 'obsadené') + '. Najprv ho vyber.'); setBusy(false); return }
      if (!r.ok) throw new Error()
      toast.success('Hotovo'); onDone()
    } catch (_) { toast.error('Akcia zlyhala'); setBusy(false) }
  }
  const title = mode === 'osadit' ? `Osadiť — ${label}` : mode === 'vybrat' ? `Vybrať — ${label}` : `Presunúť — ${label}`
  return (
    <Modal open title={title} onClose={onClose} maxWidth={460}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md, padding: SPACE.sm }}>
        {mode === 'osadit' && (
          <div>
            <div style={lbl}>Voľný diel na osadenie</div>
            <select value={pick} onChange={e => setPick(e.target.value)} style={inp}>
              <option value="">— vyber voľný {kind === 'motor' ? 'hlavný motor' : 'malý kompresor'} —</option>
              {free.map(f => <option key={f.id} value={f.id}>{f.name}{f.serial_number ? ' · č. ' + f.serial_number : ''}</option>)}
            </select>
            {free.length === 0 && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 6 }}>Žiadny voľný diel. Vytvor ho v katalógu — kategória {kind === 'motor' ? '„Hlavný motor"' : '„Malý kompresor"'} a druh dielu {kind === 'motor' ? '„Hlavný motor s prevodovkou"' : '„Malý kompresor (na omietačke)"'} — alebo vyber diel z iného stroja.</div>}
          </div>
        )}
        {mode === 'vybrat' && (
          <div>
            <div style={lbl}>Kam ide diel?</div>
            <div style={{ display: 'flex', gap: SPACE.sm }}>
              <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 6, border: `1px solid ${removeStatus === 'v_servise' ? COLORS.warn : COLORS.line}`, borderRadius: RADIUS.sm, padding: '8px 10px', cursor: 'pointer' }}><input type="radio" checked={removeStatus === 'v_servise'} onChange={() => setRemoveStatus('v_servise')} /> Na servis</label>
              <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 6, border: `1px solid ${removeStatus === 'dostupne' ? COLORS.add : COLORS.line}`, borderRadius: RADIUS.sm, padding: '8px 10px', cursor: 'pointer' }}><input type="radio" checked={removeStatus === 'dostupne'} onChange={() => setRemoveStatus('dostupne')} /> Voľný (rezerva)</label>
            </div>
            <div style={{ fontSize: TYPO.sizes.xs, color: '#92400e', marginTop: 6 }}>Stroj {fmtCode(machine.code)} zostane bez dielu „{label}".</div>
          </div>
        )}
        {mode === 'presunut' && (
          <div>
            <div style={lbl}>Cieľový stroj (omietačka)</div>
            <select value={target} onChange={e => setTarget(e.target.value)} style={inp}>
              <option value="">— vyber stroj —</option>
              {machines.map(o => <option key={o.id} value={o.id}>{o.name} {fmtCode(o.code)}</option>)}
            </select>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 6 }}>Cieľ musí mať prázdny slot pre tento diel (inak najprv vyber jeho diel).</div>
          </div>
        )}
        <div>
          <div style={lbl}>Dôvod / poznámka</div>
          <input value={reason} onChange={e => setReason(e.target.value)} placeholder="napr. porucha motora, plánovaná výmena…" style={inp} />
        </div>
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose}>Zrušiť</BtnGhost>
          <BtnAdd onClick={submit} disabled={busy}>{busy ? '…' : 'Potvrdiť'}</BtnAdd>
        </div>
      </div>
    </Modal>
  )
}

function SwapPartDialog({ record, part, partLabel, omietacky, onClose, onDone }) {
  const [target, setTarget] = useState('')
  const [note, setNote] = useState('')
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  const tgt = omietacky.find(o => o.id === target)
  const myS = part === 'motor' ? record.motor_serial : record.compressor_serial
  const tgtS = tgt ? (part === 'motor' ? tgt.motor_serial : tgt.compressor_serial) : ''
  const save = async () => {
    if (!target) { toast.error('Vyber cieľový stroj'); return }
    setBusy(true)
    try {
      const r = await fetchAuth('/api/loan-items/swap-part', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ item_a: record.id, item_b: target, part, note }) })
      if (!r.ok) throw new Error('swap')
      toast.success('Diel prehodený — zapísané do histórie')
      onDone()
    } catch (_) { toast.error('Chyba pri výmene dielu') } finally { setBusy(false) }
  }
  return (
    <Modal open title={`Prehodiť: ${partLabel}`} onClose={onClose} width={520}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Vymení {partLabel.toLowerCase()} medzi týmto strojom a cieľovým (vzájomná výmena výrobných čísel). Zapíše sa do histórie.</div>
        <Field label="Tento stroj">
          <div style={{ fontWeight: 600 }}>{record.name} {fmtCode(record.code)} <span style={{ color: COLORS.muted, fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs }}>· č. {myS || '—'}</span></div>
        </Field>
        <Field label="Cieľový stroj (omietačka) *">
          <SearchableSelect value={target} onChange={setTarget} placeholder="Vyber omietačku…"
            options={omietacky.map(o => ({ value: o.id, label: `${o.name} ${fmtCode(o.code)} · č. ${(part === 'motor' ? o.motor_serial : o.compressor_serial) || '—'}` }))} />
        </Field>
        {tgt && <div style={{ fontSize: TYPO.sizes.sm, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.sm }}>
          Po výmene: <b>{record.name} {fmtCode(record.code)}</b> dostane č. <b>{tgtS || '—'}</b>, <b>{tgt.name} {fmtCode(tgt.code)}</b> dostane č. <b>{myS || '—'}</b>.
        </div>}
        <Field label="Poznámka (dôvod výmeny)">
          <textarea value={note} onChange={e => setNote(e.target.value)} rows={2}
            placeholder="napr. motor na č.11 mal poruchu, prehodený funkčný z č.12"
            style={{ width: '100%', padding: '6px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }} />
        </Field>
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost>
          <BtnAdd onClick={save} disabled={busy || !target}>{busy ? 'Prehadzujem…' : 'Prehodiť diel'}</BtnAdd>
        </div>
      </div>
    </Modal>
  )
}

function ZostavaTab({ record, onReload }) {
  const { user } = useAuth()
  const canEdit = ['admin', 'owner', 'owner_view', 'office_manager', 'service'].includes(user?.role)
  const toast = useToast()
  const [all, setAll] = useState(null)
  const [picking, setPicking] = useState('')
  const load = () => fetchAuth('/api/loan-items').then(r => r.ok ? r.json() : []).then(d => setAll(Array.isArray(d) ? d : [])).catch(() => setAll([]))
  useEffect(() => { load() }, [record.id])
  // Omietačka = embedded model (rám/motor/kompresor) → swap UI namiesto parent_id komponentov (58.2.2)
  if (isOmietacka(record.category)) {
    return <div style={{ paddingTop: SPACE.md }}><OmietackaSwap record={record} onReload={onReload} /></div>
  }
  const move = async (compId, parentId) => {
    try {
      const r = await fetchAuth(`/api/loan-items/${compId}/move-component`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ parent_id: parentId }) })
      if (!r.ok) throw new Error('move'); toast.success(parentId ? 'Komponent osadený do stroja' : 'Komponent vybraný (voľný)'); load(); if (onReload) onReload()
    } catch (_) { toast.error('Chyba pri presune komponentu') }
  }
  if (all === null) return <div style={{ paddingTop: SPACE.md, color: COLORS.muted }}>Načítavam zostavu…</div>
  const installed = all.filter(x => x.parent_id === record.id && x.id !== record.id)
  const free = all.filter(x => x.tracking === 'kus' && x.active !== 0 && (!x.parent_id || x.parent_id === '') && x.id !== record.id)
  const myParent = record.parent_id ? all.find(x => x.id === record.parent_id) : null
  const _expl = explodedConfig(record.category)
  return (
    <div style={{ paddingTop: SPACE.md, display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      {_expl && <PartExploded centerImg={_expl.centerImg} centerLabel={_expl.centerLabel} parts={_expl.parts} />}
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Stroj = telo + osadené komponenty (zameniteľné, NA KUS — vlastné výr. číslo + servisná kniha). Ústava 58.2.</div>
      {myParent && <div style={{ padding: SPACE.sm, background: COLORS.navBg, borderRadius: RADIUS.md, fontSize: TYPO.sizes.sm }}>Tento diel je aktuálne osadený v stroji: <b>{myParent.name}</b>{myParent.serial_number ? ` · č. ${myParent.serial_number}` : ''} {canEdit && <BtnGhost size="sm" onClick={() => move(record.id, '')}>Vybrať</BtnGhost>}</div>}
      <div>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>Osadené komponenty ({installed.length})</div>
        {installed.length === 0 ? <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Žiadne osadené komponenty.</div> :
          installed.map(c => (
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <div style={{ flex: 1, minWidth: 0 }}><b>{c.name}</b>{c.serial_number && <span style={{ color: COLORS.muted, fontFamily: TYPO.mono, marginLeft: 8, fontSize: TYPO.sizes.xs }}>č. {c.serial_number}</span>}</div>
              <StatusTag status={c.status} />
              {canEdit && <BtnGhost size="sm" onClick={() => move(c.id, '')}>Vybrať</BtnGhost>}
            </div>
          ))}
      </div>
      {canEdit && record.tracking === 'kus' && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 3 }}>Osadiť voľný komponent (NA KUS)</div>
            <SearchableSelect value={picking} onChange={setPicking} placeholder="Vyber voľný komponent…"
              options={free.map(f => ({ value: f.id, label: f.name + (f.serial_number ? (' · č. ' + f.serial_number) : '') }))} />
          </div>
          <BtnAdd onClick={() => { if (picking) { move(picking, record.id); setPicking('') } }}>+ Osadiť</BtnAdd>
        </div>
      )}
    </div>
  )
}

function RecordModal({ open, record, user, defaultCat, onClose, onSaved, onReload }) {
  const isNew = !record
  const toast = useToast()
  const [mainPhoto, setMainPhoto] = useState(record?.photo_url || '')
  const [cats, setCats] = useState([])
  useEffect(() => {
    if (!open) return
    fetchAuth('/api/loan-items/categories')
      .then(r => r.ok ? r.json() : [])
      .then(setCats)
      .catch(() => {})
  }, [open])

  const ed = useRecordEditor({
    resource: CFG.resource,
    id: record?.id || null,
    user,
    initial: {
      code:          record?.code          || '',
      name:          record?.name          || '',
      category:      record?.category      || defaultCat || '',
      part_type:     record?.part_type     || '',
      description:   record?.description   || '',
      nfc_tag:       record?.nfc_tag       || '',
      tracking:      record?.tracking      || (defaultCat === 'Lešenie' ? 'ks' : 'kus'),
      serial_number: record?.serial_number || '',
      model:         record?.model         || '',
      color:         record?.color         || '',
      frame_serial:      record?.frame_serial      || '',
      motor_serial:      record?.motor_serial      || '',
      compressor_serial: record?.compressor_serial || '',
      compressor_color:  record?.compressor_color  || '',
      motor_connector:      record?.motor_connector      || '',
      compressor_connector: record?.compressor_connector || '',
      plc_enabled:   record?.plc_enabled ? true : false,
      plc_device_id: record?.plc_device_id || '',
      qty:           record?.qty           || 1,
      rate:          record?.rate          || 0,
      rate_unit:     record?.rate_unit     || '€/deň',
      status:        record?.status        || 'dostupne',
      notes:         record?.notes         || '',
      photo_url:     record?.photo_url     || '',
    },
    fields: EDIT_FIELDS,
    onSubmit: async (values) => {
      const r = await fetchAuth(
        isNew ? CFG.apiBase : `${CFG.apiBase}/${record.id}`,
        { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(values) }
      )
      if (!r.ok) {
        const d = await r.json().catch(() => ({}))
        // dedup (ústava sek. 13) — backend vracia 409 pri duplicite
        if (r.status === 409) throw new Error(d.message || 'Taký záznam už existuje.')
        throw new Error(d.error || 'Uloženie zlyhalo.')
      }
    },
  })

  // Sync fotky (galéria/príloha) -> formulár, aby Uložiť ju uložil a nehlásil „Žiadne zmeny" (Mirko 2026-06-26)
  useEffect(() => {
    if (!isNew && mainPhoto !== (record?.photo_url || '')) ed.set('photo_url', mainPhoto)
  }, [mainPhoto])  // eslint-disable-line react-hooks/exhaustive-deps

  if (!open) return null

  const doClose = () => ed.requestClose(onClose)

  const validate = (v) => {
    if (!v.name || !v.name.trim()) return 'Názov je povinný.'
    return null
  }

  const handleConfirm = async () => {
    const ok = await ed.submit()
    if (ok) onSaved()
  }

  const readOnly = !ed.canEdit

  return (
    <>
      <Modal
        open
        onClose={doClose}
        onDirtyClose={doClose}
        isDirty={ed.isDirty}
        title={isNew ? CFG.newLabel : `Upraviť — ${record.name}`}
        subtitle={ed.phase === 'confirm' ? 'Skontroluj zmeny pred uložením' : ''}
        maxWidth={640}
        footer={
          ed.phase === 'form' ? (
            <>
              <BtnGhost onClick={doClose}>Zrušiť</BtnGhost>
              <BtnAdd onClick={() => ed.goConfirm(validate)} disabled={readOnly}>
                Uložiť →
              </BtnAdd>
            </>
          ) : (
            <>
              <BtnGhost onClick={ed.back}>← Späť na úpravu</BtnGhost>
              <BtnAdd onClick={handleConfirm} disabled={ed.submitting}>
                {ed.submitting ? 'Ukladám…' : '✓ Potvrdiť uloženie'}
              </BtnAdd>
            </>
          )
        }
      >
        {/* LOCK banner — záznam upravuje niekto iný (ústava 53.7) */}
        {readOnly && ed.lockedBy && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>
            Záznam práve upravuje <strong>{ed.lockedBy}</strong>. Editácia je zamknutá.
          </div>
        )}

        {ed.error && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>{ed.error}</div>
        )}

        {ed.phase === 'form' ? (
          // ── FORM fáza ──────────────────────────────────────────────
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            <PozicovnaForm ed={ed} readOnly={readOnly} inputStyle={inputStyle} cats={cats} />
            {/* Foto položky (ústava 58.1 — fotky aj cez mobil; pri NA KUS aj komponenty/zostava) */}
            <div style={{ borderTop: `1px solid ${COLORS.line}`, paddingTop: SPACE.md }}>
              <div style={{ fontSize: TYPO.sizes.xs, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', marginBottom: SPACE.sm }}>Fotky položky</div>
              {isNew
                ? <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
                    {(() => { const gal = !ed.values.photo_url && partPhoto({ category: ed.values.category, name: ed.values.name }); return gal ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md, background: COLORS.bgSoft, borderRadius: RADIUS.md, padding: SPACE.sm }}>
                        <img src={gal} alt="" style={{ width: 56, height: 56, objectFit: 'contain', flexShrink: 0 }} />
                        <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>Štandardný obrázok z galérie (podľa kategórie) — netreba nahrávať. Pre vlastný použi pole nižšie.</div>
                      </div>) : null })()}
                    <PhotoCapture label="Vlastná fotka (lešenie / vlastné položky)" value={ed.values.photo_url} onChange={v => ed.set('photo_url', v)} hint="Lešenie a položky bez galérie: nahraj fotku tu." />
                    <GalleryPicker value={ed.values.photo_url} onPick={v => ed.set('photo_url', v)} />
                  </div>
                : <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
                    <GalleryPicker value={mainPhoto} onPick={(url) => { ed.set('photo_url', url); setMainPhoto(url); toast.success('Fotka vybratá — klikni Uložiť') }} />
                    <AttachmentsPanel entityType="loan_item" entityId={record.id}
                    mainUrl={mainPhoto}
                    onSetMain={async (url) => {
                      try {
                        const r = await fetchAuth(`/api/loan-items/${record.id}/set-photo`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ url }) })
                        if (!r.ok) throw new Error()
                        setMainPhoto(url); toast.success('Miniatúra nastavená'); if (onReload) onReload()
                      } catch (_) { toast.error('Nepodarilo sa nastaviť miniatúru') }
                    }}
                    onChanged={async () => {
                      try {
                        const r = await fetchAuth('/api/loan-items')
                        if (r.ok) { const list = await r.json(); const it = (Array.isArray(list) ? list : []).find(x => x.id === record.id); if (it) setMainPhoto(it.photo_url || '') }
                      } catch (_) {}
                      if (onReload) onReload()
                    }} /></div>}
            </div>
          </div>
        ) : (
          // ── CONFIRM fáza — DIFF prehľad (ústava 53.8) ───────────────
          <div>
            {isNew ? (
              <p style={{ fontSize: TYPO.sizes.base, color: COLORS.text }}>
                Vytvorí sa nový záznam <strong>{ed.values.name}</strong>.
              </p>
            ) : ed.diff.length === 0 ? (
              <p style={{ color: COLORS.muted }}>Žiadne zmeny.</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                <thead>
                  <tr style={{ background: TINT.nav }}>
                    <th style={thStyle}>Pole</th>
                    <th style={thStyle}>Pôvodné</th>
                    <th style={thStyle}>Nové</th>
                  </tr>
                </thead>
                <tbody>
                  {ed.diff.map(d => (
                    <tr key={d.name}>
                      <td style={tdStyle}>{d.label}</td>
                      <td style={{ ...tdStyle, color: COLORS.muted, textDecoration: 'line-through' }}>
                        {d.from}
                      </td>
                      <td style={{ ...tdStyle, color: COLORS.add, fontWeight: TYPO.weights.semibold }}>
                        {d.to}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </Modal>

      {/* DIRTY dialóg — Uložiť / Pokračovať / Zahodiť (ústava 53.1) */}
      <Modal.DirtyConfirm {...ed.dirtyProps} />
    </>
  )
}

function PozicovnaForm({ ed, readOnly, inputStyle, cats }) {
  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: SPACE.md }}>
        <Field label="Kód (č. — rozlišuje rovnaké názvy)">
          <input type="text" value={ed.values.code} disabled={readOnly}
            placeholder="napr. 11 → zobrazí sa č.11"
            onChange={e => ed.set('code', e.target.value)} style={inputStyle} />
        </Field>
        <Field label="Názov *">
          <input type="text" value={ed.values.name} disabled={readOnly}
            placeholder="Kompresor Atlas Copco GA 11"
            onChange={e => ed.set('name', e.target.value)} style={inputStyle} />
        </Field>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
        <Field label="Kategória">
          <SearchableSelect value={ed.values.category}
            onChange={v => ed.set('category', v)}
            options={(cats || []).map(c => ({ value: c, label: c }))}
            placeholder="Hľadať alebo pridať…"
            allowCreate />
        </Field>
        <Field label="Režim evidencie">
          <SearchableSelect value={ed.values.tracking}
            onChange={v => ed.set('tracking', v)}
            options={TRACKING_OPTS} />
        </Field>
      </div>
      {ed.values.tracking === 'kus' && (
        <Field label="Druh dielu — čo to je v zostave omietačky">
          <SearchableSelect value={ed.values.part_type}
            onChange={v => ed.set('part_type', v)}
            options={PART_TYPE_OPTS}
            emptyLabel="— nie je diel, je to samostatný stroj —" />
          <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3 }}>
            Rám je základ a vždy zostáva — menia sa hlavný motor a malý kompresor. Podľa tohto poľa Matrix vie,
            čo smie osadiť do ktorého slotu: malý kompresor omietačky nie je to isté ako kompresor pri sile.
          </div>
        </Field>
      )}
      <Field label="Popis produktu">
        <input type="text" value={ed.values.description} disabled={readOnly}
          placeholder="napr. Omietačka PFT G4 — 5 vriec + sonda"
          onChange={e => ed.set('description', e.target.value)} style={inputStyle} maxLength={120} />
        <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3 }}>Krátky a výstižný popis produktu (1 veta, max ~120 znakov) — zobrazí sa v zozname aj na doklade.</div>
      </Field>
      <Field label="NFC tag (číslo)">
        <input type="text" value={ed.values.nfc_tag} disabled={readOnly}
          placeholder="číslo/ID NFC tagu nalepeného na stroji (ak je)"
          onChange={e => ed.set('nfc_tag', e.target.value)} style={inputStyle} />
      </Field>
      {ed.values.tracking === 'kus' ? (
        isOmietacka(ed.values.category) ? (
          <OmietackaParts ed={ed} readOnly={readOnly} inputStyle={inputStyle} />
        ) : (
        <>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.md }}>
          <Field label="Výrobné číslo">
            <input type="text" value={ed.values.serial_number} disabled={readOnly}
              onChange={e => ed.set('serial_number', e.target.value)} style={inputStyle} />
          </Field>
          <Field label="Model">
            <input type="text" value={ed.values.model} disabled={readOnly}
              onChange={e => ed.set('model', e.target.value)} style={inputStyle} />
          </Field>
          <Field label="Farba">
            <input type="text" value={ed.values.color} disabled={readOnly}
              onChange={e => ed.set('color', e.target.value)} style={inputStyle} />
          </Field>
        </div>
        {/(motor|kompres)/i.test(ed.values.category || '') && (
          <Field label="Koncovka (zásuvka)">
            <ConnectorField value={ed.values.motor_connector} onChange={v => ed.set('motor_connector', v)} readOnly={readOnly} />
          </Field>
        )}
        </>
        )
      ) : (
        <Field label="Počet kusov (na sklade)">
          <input type="number" min="0" value={ed.values.qty} disabled={readOnly}
            onChange={e => ed.set('qty', Number(e.target.value) || 0)} style={inputStyle} />
        </Field>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.md }}>
        <Field label="Sadzba">
          <input type="number" step="0.01" value={ed.values.rate} disabled={readOnly}
            onChange={e => ed.set('rate', Number(e.target.value) || 0)} style={inputStyle} />
        </Field>
        <Field label="Jednotka sadzby">
          <SearchableSelect value={ed.values.rate_unit}
            onChange={v => ed.set('rate_unit', v)}
            options={RATE_UNITS} />
        </Field>
        <Field label="Stav položky">
          <SearchableSelect value={ed.values.status}
            onChange={v => ed.set('status', v)}
            options={[
              { value: 'dostupne',  label: 'Dostupné' },
              { value: 'pozicane',  label: 'Požičané' },
              { value: 'v_servise', label: 'V servise' },
              { value: 'vyradene',  label: 'Vyradené' },
            ]} />
        </Field>
      </div>
      <Field label="Poznámka">
        <textarea value={ed.values.notes} disabled={readOnly}
          onChange={e => ed.set('notes', e.target.value)} rows={3}
          style={{ ...inputStyle, resize: 'vertical' }} />
      </Field>
    </>
  )
}

// Omietačka = jedna položka z 3 zameniteľných častí (Mirko 2026-06-10)
function PartBadge({ text, color }) {
  return <span style={{ fontSize: 10, fontWeight: 800, color: '#fff', background: color, borderRadius: RADIUS.full, padding: '1px 8px', whiteSpace: 'nowrap' }}>{text}</span>
}
// Čiarové (line) ikony dielov — lucide štýl, NIE emoji
function PartIcon({ kind, color }) {
  const p = { width: 17, height: 17, viewBox: '0 0 24 24', fill: 'none', stroke: color || 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round', style: { flexShrink: 0 } }
  if (kind === 'frame') return <svg {...p}><rect x="3" y="3" width="18" height="18" rx="2" /><rect x="8" y="8" width="8" height="8" rx="1" /></svg>
  if (kind === 'motor') return <svg {...p}><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="3" /><path d="M12 4v2M12 18v2M4 12h2M18 12h2" /></svg>
  return <svg {...p}><ellipse cx="12" cy="6" rx="8" ry="3" /><path d="M4 6v12a8 3 0 0 0 16 0V6" /><path d="M4 12a8 3 0 0 0 16 0" /></svg>
}
// Foto-ikona dielu v Zostave — reálna foto (ram/motor/kompresor png), fallback na čiarovú ikonu (Mirko 2026-06-13)
function PartPhotoIcon({ kind, color }) {
  const [err, setErr] = React.useState(false)
  const file = { frame: 'ram.png', motor: 'motor.png', compressor: 'kompresor.png' }[kind]
  if (err || !file) return <div style={{ width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><PartIcon kind={kind} color={color} /></div>
  return <img src={PART_PHOTO_BASE + file} alt="" onError={() => setErr(true)} style={{ width: 48, height: 48, objectFit: 'contain', flexShrink: 0 }} />
}
// Koncovka/zásuvka — dropdown z číselníka + „pridať nový typ" bez programátora (Mirko 2026-06-13)
function ConnectorField({ value, onChange, readOnly }) {
  const toast = useToast()
  const [connectors, setConnectors] = useState([])
  useEffect(() => { fetchAuth('/api/loan-connectors').then(r => r.ok ? r.json() : []).then(d => setConnectors(Array.isArray(d) ? d : [])).catch(() => {}) }, [])
  const add = async () => {
    const v = (window.prompt('Nový typ koncovky / zásuvky (napr. 5×63A, CEE 32A):') || '').trim()
    if (!v) return null
    try { const r = await fetchAuth('/api/loan-connectors', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ value: v }) }); if (!r.ok) throw new Error(); const list = await r.json(); setConnectors(Array.isArray(list) ? list : []); toast.success('Typ koncovky pridaný'); return v }
    catch (_) { toast.error('Nepodarilo sa pridať'); return null }
  }
  const inp = { width: '100%', padding: '8px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, boxSizing: 'border-box' }
  return (
    <select value={value || ''} disabled={readOnly}
      onChange={async e => { if (e.target.value === '__add__') { const nv = await add(); if (nv) onChange(nv) } else onChange(e.target.value) }} style={inp}>
      <option value="">— nezadané —</option>
      {connectors.map(c => <option key={c} value={c}>{c}</option>)}
      {value && !connectors.includes(value) && <option value={value}>{value}</option>}
      <option value="__add__">+ pridať nový typ…</option>
    </select>
  )
}
function OmietackaParts({ ed, readOnly, inputStyle }) {
  const box = { border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.sm, background: COLORS.bgSoft }
  const head = { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }
  const title = { fontSize: TYPO.sizes.sm, fontWeight: 800, color: COLORS.nav }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.nav, background: TINT.info || '#eef4ff', border: `1px solid ${COLORS.info || COLORS.brand}`, borderRadius: RADIUS.md, padding: SPACE.sm, lineHeight: 1.5 }}>
        Toto je <b>RÁM</b> = identita stroja (vždy zostáva). <b>Motor a kompresor sú samostatné kusy</b> — vytvor ich v katalógu (kategória „Hlavný motor" / „Malý kompresor", druh dielu vyplň, vrátane koncovky) a <b>osaď cez tab Zostava</b>. Tam sa aj berú na servis / prehadzujú medzi strojmi.
      </div>
      {/* RÁM — identita, vždy zostáva */}
      <div style={box}>
        <div style={head}><PartPhotoIcon kind="frame" color={COLORS.brand} /><span style={title}>Rám omietačky</span><PartBadge text="VŽDY ZOSTÁVA — identita stroja" color={COLORS.brand} /></div>
        <Field label="Rám — výrobné číslo">
          <input type="text" value={ed.values.frame_serial} disabled={readOnly}
            placeholder="výr. číslo rámu" onChange={e => ed.set('frame_serial', e.target.value)} style={inputStyle} />
        </Field>
      </div>
      {/* PLC — diaľkové monitorovanie (G4 prototyp) */}
      <div style={box}>
        <div style={head}><PartIcon kind="motor" color={COLORS.muted} /><span style={title}>Diaľkové monitorovanie / PLC</span><PartBadge text="PROTOTYP" color={COLORS.muted} /></div>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 8, lineHeight: 1.45 }}>
          Pre G4 prototyp s PLC (diaľkové monitorovanie + spustenie). Zatiaľ evidencia — keď PLC začne posielať dáta a prijímať príkaz „spustiť", napojí sa naživo do tejto sekcie.
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: SPACE.md, alignItems: 'end' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: TYPO.sizes.sm, paddingBottom: 8, whiteSpace: 'nowrap' }}>
            <input type="checkbox" checked={!!ed.values.plc_enabled} disabled={readOnly} onChange={e => ed.set('plc_enabled', e.target.checked)} /> PLC pripojené
          </label>
          <Field label="PLC ID / IP zariadenia">
            <input type="text" value={ed.values.plc_device_id} disabled={readOnly || !ed.values.plc_enabled}
              placeholder="napr. 192.168.x.x / device-id" onChange={e => ed.set('plc_device_id', e.target.value)} style={inputStyle} />
          </Field>
        </div>
      </div>
    </div>
  )
}

function Field({ label, children }) {
  return (
    <label style={{ display: 'block' }}>
      <div style={{
        fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
        color: COLORS.muted, marginBottom: 4, textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}>{label}</div>
      {children}
    </label>
  )
}

const inputStyle = {
  width: '100%',
  padding: '6px 10px',
  fontSize: TYPO.sizes.base,
  fontFamily: 'inherit',
  border: `1px solid ${COLORS.line}`,
  borderRadius: RADIUS.md,
  outline: 'none',
  boxSizing: 'border-box',
}
const thStyle = {
  textAlign: 'left', padding: '6px 10px',
  fontSize: TYPO.sizes.xs, color: COLORS.nav,
  textTransform: 'uppercase', letterSpacing: '0.04em',
  borderBottom: `1px solid ${COLORS.line}`,
}
const tdStyle = {
  padding: '6px 10px',
  borderBottom: `1px solid ${COLORS.lineSoft}`,
}

// ╔══════════════════════════════════════════════════════════════════╗
// ║  DoD CHECKLIST — skopíruj do HANDOFF, odškrtni pred dokončením    ║
// ║  (ústava 9.D.1 bod 3). Modul NIE JE hotový kým nie sú všetky ✅.  ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  [ ] CFG vyplnené (resource, apiBase, labels)                    ║
// ║  [ ] EDIT_FIELDS = všetky editovateľné polia (kvôli DIFF)        ║
// ║  [ ] LOCK funguje — test 2 okná naraz (53.7)                     ║
// ║  [ ] DIRTY dialóg pri zatvorení s neuloženými zmenami (53.1)     ║
// ║  [ ] Form → Confirm + DIFF pred uložením (12.0/3, 53.8)         ║
// ║  [ ] HistoryPanel ukazuje audit záznamu (12.0/1)                 ║
// ║  [ ] hľadanie v zozname funguje (56)                             ║
// ║  [ ] žiadny plain <select> — len SearchableSelect (56.11)        ║
// ║  [ ] žiadne inline farby pozadia — len TINT/tint() (21.15)       ║
// ║  [ ] dedup — backend vracia 409 pri duplicite (13)               ║
// ║  [ ] mod+N a / skratky + cheatsheet (54)                         ║
// ║  [ ] starý modul porovnaný — všetky polia/funkcie prenesené      ║
// ║  [ ] ÚSTAVA-REVIEW — druhý prechod kódu bod po bode (9.D.3)      ║
// ╚══════════════════════════════════════════════════════════════════╝

// ══════════════════════════════════════════════════════════════════
// SERVIS CUDZÍCH STROJOV (ústava 58.7) — oprava strojov zákazníkov
// ══════════════════════════════════════════════════════════════════
const SJ_STATUS = { received: 'Prijatý', repairing: 'V oprave', done: 'Odovzdaný' }
const SJ_FILTERS = [
  { key: 'all', label: 'Všetky' },
  { key: 'received', label: 'Prijaté', color: COLORS.nav },
  { key: 'repairing', label: 'V oprave', color: COLORS.warn },
  { key: 'done', label: 'Odovzdané', color: COLORS.add },
]
function sjColor(s) { return s === 'done' ? COLORS.add : s === 'repairing' ? COLORS.warn : COLORS.nav }
const SJ_INPUT = { width: '100%', padding: '6px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, background: COLORS.bg, color: COLORS.text, boxSizing: 'border-box' }

function ServisCudzich() {
  const { user } = useAuth()
  const canEdit = ['admin', 'owner', 'owner_view', 'office_manager', 'service'].includes(user?.role)
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState('all')
  const [selId, setSelId] = useState(null)
  const [modal, setModal] = useState(null)
  const load = () => { setLoading(true); fetchAuth('/api/service-jobs').then(r => r.ok ? r.json() : []).then(d => setRows(Array.isArray(d) ? d : [])).catch(() => setRows([])).finally(() => setLoading(false)) }
  useEffect(() => { load() }, [])
  const filtered = rows.filter(r => (filter === 'all' || r.status === filter) && (!search.trim() || Object.values(r).some(v => v != null && hladaj(String(v), search.trim().toLowerCase()))))
  const sel = rows.find(r => r.id === selId) || null
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <PageHeader title="Servis cudzích strojov" subtitle={`${filtered.length} z ${rows.length}`}>
        {canEdit && <BtnAdd onClick={() => setModal({ job: null })}>+ Nová oprava</BtnAdd>}
      </PageHeader>
      <div style={{ height: SPACE.md }} />
      <MasterDetail
        left={<>
          <SearchInput value={search} onChange={setSearch} placeholder="Hľadať (stroj, zákazník)…" />
          <FilterChips options={SJ_FILTERS} value={filter} onChange={setFilter} />
          <div style={{ flex: 1, overflow: 'auto', padding: 6 }}>
            {loading ? <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Načítavam…</div>
              : filtered.length === 0 ? <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Žiadne opravy.</div>
                : filtered.map(j => (
                  <ListRow key={j.id} dataId={j.id} selected={j.id === selId} onClick={() => setSelId(j.id)} onDoubleClick={() => setModal({ job: j })}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: TYPO.weights.semibold, color: COLORS.text, wordBreak: 'break-word' }}>{j.machine_name || '(stroj)'}{j.machine_serial ? ' · č. ' + j.machine_serial : ''}</div>
                        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2 }}>{j.customer_name || '—'} · {j.received_date || ''}</div>
                      </div>
                      <span style={{ flexShrink: 0, fontSize: TYPO.sizes.xs, fontWeight: 700, color: sjColor(j.status) }}>{SJ_STATUS[j.status] || j.status}</span>
                    </div>
                  </ListRow>
                ))}
          </div>
        </>}
        right={sel ? <ServisJobDetail job={sel} canEdit={canEdit} onEdit={() => setModal({ job: sel })} /> : <EmptyPane text="Vyber opravu zo zoznamu vľavo" />}
      />
      {modal && <ServisJobModal job={modal.job} onClose={() => setModal(null)} onSaved={() => { setModal(null); load() }} />}
    </div>
  )
}

function ServisJobDetail({ job, canEdit, onEdit }) {
  const total = (Number(job.parts_cost) || 0) + (Number(job.labor_cost) || 0)
  return (
    <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <div style={{ height: 4, background: COLORS.brand }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md, padding: `${SPACE.md}px ${SPACE.lg}px`, borderBottom: `1px solid ${COLORS.line}`, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra, color: COLORS.text }}>{job.machine_name || '(stroj)'}</h2>
        <span style={{ fontSize: TYPO.sizes.xs, fontWeight: 700, color: sjColor(job.status) }}>{SJ_STATUS[job.status] || job.status}</span>
        <div style={{ flex: 1 }} />
        {canEdit && <Btn variant="nav" onClick={onEdit}>Upraviť</Btn>}
      </div>
      <div style={{ padding: SPACE.md, overflow: 'auto', flex: 1, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg }}>
        <div style={{ display: 'flex', gap: 8, marginBottom: SPACE.md, flexWrap: 'wrap' }}>
          <Btn variant="nav" onClick={() => printProtokol(job, 'prijem')}>Preberací</Btn>
          <Btn variant="nav" onClick={() => printProtokol(job, 'oprava')}>Protokol opravy</Btn>
          <Btn variant="nav" onClick={() => printProtokol(job, 'odovzdanie')}>Odovzdávací</Btn>
        </div>
        <DetailRow label="Zákazník" value={job.customer_name} />
        <DetailRow label="Stroj" value={job.machine_name} />
        <DetailRow label="Výrobné č." value={job.machine_serial} />
        <DetailRow label="Prijatý" value={job.received_date} />
        <DetailRow label="Stav" value={SJ_STATUS[job.status] || job.status} />
        <DetailRow label="Závada" value={job.problem_desc} />
        <DetailRow label="Oprava" value={job.repair_desc} />
        <DetailRow label="Diely €" value={(Number(job.parts_cost) || 0).toFixed(2)} />
        <DetailRow label="Práca €" value={(Number(job.labor_cost) || 0).toFixed(2)} />
        <DetailRow label="Spolu €" value={total.toFixed(2)} />
        <DetailRow label="MKsoft zákazka" value={job.mksoft_zakazka} />
        <DetailRow label="Odovzdaný" value={job.returned_date} />
        <DetailRow label="Poznámka" value={job.notes} />
      </div>
    </div>
  )
}

function ServisJobModal({ job, onClose, onSaved }) {
  const isNew = !job
  const toast = useToast()
  const [customers, setCustomers] = useState([])
  const [f, setF] = useState({
    customer_id: job?.customer_id || '', machine_name: job?.machine_name || '', machine_serial: job?.machine_serial || '',
    received_date: job?.received_date || todayLocal(), status: job?.status || 'received',
    problem_desc: job?.problem_desc || '', repair_desc: job?.repair_desc || '', parts_cost: job?.parts_cost || '', labor_cost: job?.labor_cost || '',
    mksoft_zakazka: job?.mksoft_zakazka || '', returned_date: job?.returned_date || '', notes: job?.notes || '',
  })
  const [busy, setBusy] = useState(false)
  useEffect(() => { fetchAuth('/api/customers').then(r => r.ok ? r.json() : []).then(d => setCustomers(Array.isArray(d) ? d : (d.rows || []))).catch(() => {}) }, [])
  const set = (k, v) => setF(p => ({ ...p, [k]: v }))
  const save = async () => {
    if (!f.machine_name.trim()) { toast.error('Zadaj názov stroja'); return }
    setBusy(true)
    try {
      const r = await fetchAuth(isNew ? '/api/service-jobs' : `/api/service-jobs/${job.id}`, { method: isNew ? 'POST' : 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(f) })
      if (!r.ok) throw new Error('save'); toast.success('Uložené'); onSaved()
    } catch (_) { toast.error('Chyba pri ukladaní') } finally { setBusy(false) }
  }
  return (
    <Modal open title={isNew ? 'Nová oprava — cudzí stroj' : `Upraviť — ${job.machine_name}`} onClose={onClose} maxWidth={660}
      footer={<><BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost><BtnAdd onClick={save} disabled={busy}>{busy ? 'Ukladám…' : 'Uložiť'}</BtnAdd></>}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <Field label="Zákazník (partner)"><SearchableSelect value={f.customer_id} onChange={v => set('customer_id', v)} options={customers.map(c => ({ value: c.id, label: c.name }))} placeholder="Vyber zákazníka…" /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
          <Field label="Stroj *"><input value={f.machine_name} onChange={e => set('machine_name', e.target.value)} style={SJ_INPUT} /></Field>
          <Field label="Výrobné č."><input value={f.machine_serial} onChange={e => set('machine_serial', e.target.value)} style={SJ_INPUT} /></Field>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.md }}>
          <Field label="Prijatý"><input type="date" value={f.received_date} onChange={e => set('received_date', e.target.value)} style={SJ_INPUT} /></Field>
          <Field label="Stav"><SearchableSelect value={f.status} onChange={v => set('status', v)} options={[{ value: 'received', label: 'Prijatý' }, { value: 'repairing', label: 'V oprave' }, { value: 'done', label: 'Odovzdaný' }]} /></Field>
          <Field label="Odovzdaný"><input type="date" value={f.returned_date} onChange={e => set('returned_date', e.target.value)} style={SJ_INPUT} /></Field>
        </div>
        <Field label="Závada (preberací)"><textarea value={f.problem_desc} onChange={e => set('problem_desc', e.target.value)} rows={2} style={{ ...SJ_INPUT, resize: 'vertical' }} /></Field>
        <Field label="Popis opravy"><textarea value={f.repair_desc} onChange={e => set('repair_desc', e.target.value)} rows={2} style={{ ...SJ_INPUT, resize: 'vertical' }} /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.md }}>
          <Field label="Diely €"><input type="number" step="0.01" value={f.parts_cost} onChange={e => set('parts_cost', e.target.value)} style={SJ_INPUT} /></Field>
          <Field label="Práca €"><input type="number" step="0.01" value={f.labor_cost} onChange={e => set('labor_cost', e.target.value)} style={SJ_INPUT} /></Field>
          <Field label="MKsoft zákazka"><input value={f.mksoft_zakazka} onChange={e => set('mksoft_zakazka', e.target.value)} placeholder="č. (VSOST párovanie)" style={SJ_INPUT} /></Field>
        </div>
        <Field label="Poznámka"><textarea value={f.notes} onChange={e => set('notes', e.target.value)} rows={2} style={{ ...SJ_INPUT, resize: 'vertical' }} /></Field>
      </div>
    </Modal>
  )
}

// 3 protokoly (ústava 58.7) — tlačiteľné, podpisy + časová pečiatka
function printProtokol(job, kind) {
  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  const titles = { prijem: 'PREBERACÍ PROTOKOL', oprava: 'PROTOKOL O OPRAVE', odovzdanie: 'ODOVZDÁVACÍ PROTOKOL' }
  const ts = new Date().toISOString().replace('T', ' ').slice(0, 19)
  const total = ((Number(job.parts_cost) || 0) + (Number(job.labor_cost) || 0)).toFixed(2)
  const rows = [['Zákazník', job.customer_name || '—'], ['Stroj', job.machine_name || '—']]
  if (job.machine_serial) rows.push(['Výrobné číslo', job.machine_serial])
  rows.push(['Dátum prijatia', job.received_date || '—'])
  if (kind === 'prijem') rows.push(['Popis závady', job.problem_desc || '—'])
  if (kind === 'oprava') { rows.push(['Popis závady', job.problem_desc || '—'], ['Vykonaná oprava', job.repair_desc || '—'], ['Diely €', (Number(job.parts_cost) || 0).toFixed(2)], ['Práca €', (Number(job.labor_cost) || 0).toFixed(2)], ['SPOLU €', total]) }
  if (kind === 'odovzdanie') { rows.push(['Vykonaná oprava', job.repair_desc || '—'], ['SPOLU €', total], ['Dátum odovzdania', job.returned_date || ts.slice(0, 10)]) }
  if (job.mksoft_zakazka) rows.push(['Č. zákazky (MKsoft)', job.mksoft_zakazka])
  if (job.notes) rows.push(['Poznámka', job.notes])
  const trs = rows.map(([k, v]) => `<tr><td class="k">${esc(k)}</td><td class="v">${esc(v)}</td></tr>`).join('')
  const sign = kind === 'prijem'
    ? `<div class="sg"><div class="line"><div class="who">Odovzdal — ${esc(job.customer_name || 'zákazník')}</div>dátum a podpis</div></div><div class="sg"><div class="line"><div class="who">Prevzal — KAMIR s.r.o.</div>dátum a podpis</div></div>`
    : kind === 'oprava'
      ? `<div class="sg"><div class="line"><div class="who">Opravu vykonal — KAMIR s.r.o.</div>dátum a podpis</div></div><div class="sg"><div class="line"><div class="who">Dátum</div>${esc(ts.slice(0, 10))}</div></div>`
      : `<div class="sg"><div class="line"><div class="who">Prevzal — ${esc(job.customer_name || 'zákazník')}</div>dátum a podpis</div></div><div class="sg"><div class="line"><div class="who">Odovzdal — KAMIR s.r.o.</div>dátum a podpis</div></div>`
  const html = `<!DOCTYPE html><html lang="sk"><head><meta charset="utf-8"><title>${esc(titles[kind])} ${esc(job.id)}</title>
<style>*{box-sizing:border-box}body{font-family:-apple-system,system-ui,'Segoe UI',Arial,sans-serif;color:#1f2937;margin:0;background:#d9d6d1;padding:22px;font-size:13px}
.toolbar{max-width:800px;margin:0 auto 12px}.btn{background:#16a34a;color:#fff;border:none;padding:9px 16px;border-radius:8px;font-weight:700;cursor:pointer}
.page{max-width:800px;margin:0 auto;background:#fff;padding:28px 32px;box-shadow:0 1px 4px rgba(0,0,0,.12)}
.top{display:flex;align-items:flex-start;gap:16px;border-bottom:3px solid #ef9350;padding-bottom:12px}.top img{height:44px}
.ttl{flex:1;text-align:center}.ttl h1{margin:0;font-size:20px;letter-spacing:1px}.ttl .sub{color:#d97a3a;font-weight:700;margin-top:3px}
.docno{text-align:right;font-size:12px;color:#6b6359}
table{width:100%;border-collapse:collapse;margin-top:16px}td{border:1px solid #e7e2db;padding:7px 10px;vertical-align:top}
td.k{width:210px;color:#6b6359;font-weight:600;background:#faf7f2}td.v{font-weight:600}
.sign{display:grid;grid-template-columns:1fr 1fr;gap:40px;margin-top:50px}.sg{text-align:center}.sg .line{border-top:1px solid #555;margin-top:42px;padding-top:6px;font-size:12px;color:#6b6359}.sg .who{font-weight:700;color:#1f2937}
.foot{margin-top:18px;border-top:1px solid #e7e2db;padding-top:8px;font-size:10px;color:#6b6359;display:flex;justify-content:space-between}
@media print{body{background:#fff;padding:0}.toolbar{display:none}.page{box-shadow:none;max-width:100%;padding:14mm}@page{size:A4;margin:0}}</style></head><body>
<div class="toolbar"><button class="btn" onclick="window.print()">Tlačiť / Uložiť PDF</button></div>
<div class="page">
<div class="top"><img src="/uploads/kamir_logo.png" alt="KAMIR" onerror="this.style.display='none'"><div class="ttl"><h1>${esc(titles[kind])}</h1><div class="sub">Servis strojov · KAMIR s.r.o.</div></div><div class="docno">Č. <b>${esc(job.id)}</b><br>${esc(ts)}</div></div>
<table>${trs}</table>
<div class="sign">${sign}</div>
<div class="foot"><span>KAMIR s.r.o. · IČO 48029882 · Prešov · kamir.sk</span><span>Časová pečiatka: ${esc(ts)} · MATRIX</span></div>
</div></body></html>`
  const w = window.open('', '_blank'); if (w) { w.document.write(html); w.document.close() } else alert('Povoľ vyskakovacie okná.')
}
